module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "ch2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('em', [_vm._v("Chapter 2")]), _c('br'), _c('br'), _vm._v("“Honour, Justice, and Interest”"), _c('br'), _c('em', [_vm._v("John Jay’s Republican Politics and Statesmanship on the Federal Bench")])]), _vm._v(" "), _c('p', {
    staticClass: "chapauthor"
  }, [_c('em', [_vm._v("Sandra Frances VanBurkleo")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In 1779, at the height of the Deane controversy, Richard Henry Lee pronounced John Jay a “Tory friend” and “Mercantile Abettor” masquerading as a republican."), _c('sup', [_c('a', {
    attrs: {
      "id": "iench21"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench21"
    }
  }, [_vm._v("1")])]), _vm._v(" Lee’s remarks were unusually sharp. But a good many others harbored similar reservations and, in the rarefied atmosphere of American Revolution studies, such criticisms die hard. Scholars expect a great deal of founding fathers, and Jay consistently falls short of the mark. As a result, readers find one-dimensional caricatures of Jay’s political thought, values, and objectives that merely perpetuate or deny the allegations of eighteenth-century critics. David Hackett Fischer, for example, once sketched a nostalgic, slightly pathetic “conservative idealist” permanently flawed by King’s College monarchism and by yearnings for a bygone ancien regime. In this rendition, Jay rejected his own historical moment, devolving with James Kent and George Cabot into an Old Guard reactionary. Others describe an abrasive “realist” from New York more taken with the China trade than with Blackstone or Locke, for whom political and legal discourse functioned mainly as window dressing. And Richard Morris, after decades of invaluable research and editing, essentially turned the stereotype on its head. Transformed into a relatively affable patriot and closet democrat roughly equal in stature to John Mar-shall, "), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "id": "iench22"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench22"
    }
  }, [_vm._v("2")])]), _vm._v(" Morris’s Jay steadily advanced the American cause by means of shrewd diplomacy and by presciently anticipating the Marshall Court’s economic nationalism as well as its pivotal victory in "), _c('em', [_vm._v("Marbury")]), _vm._v(" v. "), _c('em', [_vm._v("Madison.")]), _c('sup', [_c('a', {
    attrs: {
      "id": "iench23"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench23"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_vm._v("An earlier version of this essay appeared under the same title in "), _c('em', [_vm._v("Journal of the Early Republic")]), _vm._v(" 4 (Fall 1984): 239-74. Portions are reprinted by permission. The author wishes to thank Edward M. Wise for valuable editorial help.")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Put differently, political and constitutional historians—unlike foreign relations scholars, who have managed to avoid interpretive extremes"), _c('sup', [_c('a', {
    attrs: {
      "id": "iench24"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench24"
    }
  }, [_vm._v("4")])]), _vm._v("—cling to time-honored caricatures of a bored, boring, and often incompetent chief justice and an insubstantial Supreme Court between 1789 and 1795. To some extent, this unflattering portrait originates in the fact of a limited body of personal writing, an unforthcoming man behind the pen, and a cryptic legal record: at critical moments, the historical record simply falls silent. But two additional factors shape the narrative: lawyer-historians bring exacting technical and practical standards to bear on Jay’s law practice and management of the high court, in the process reinforcing traditional skepticism; and scholars trained in history greatly prefer John Marshall (or, for that matter, the more pragmatic Hamilton and Madison), if only because Marshall’s charmingly darned stockings and chats with the newsboy play better on the lecture circuit than do Jay’s starched cuffs and mannered grand jury charges. For these and other reasons, constitutional historians have been content to dismiss Jay’s tenure as an embarrassing lapse in an otherwise distinguished common-law tradition.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Among constitutional historians, the long Marshallian shadow has been particularly damaging. Jay most assuredly was not Marshall; Morris’s views aside, historians have yet to forgive him for failing to be affable, flexible, and devoted to the Supreme Court for its own sake. Jay was undeniably cantankerous in dealings with legislators. His informal advisory opinions and open partisanship seem to flout the idea of an autonomous, apolitical federal judiciary, and his brusque departure for diplomacy in 1794 without first resigning the chief justiceship annoys even Morris. Most important, Jay did not secure the all-important review power around which Marshall fashioned a recognizably modern, uniquely American appellate practice after the “midnight judges” episode, in the process insulating the Court from the more egregious inroads of what Jay called “political grubs.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "iench25"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench25"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hence, scholars typically portray the Jay Court as the Marshall Court writ small—a primitive, amorphous prelude to the durable consolidations "), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _vm._v("pursued after Jefferson’s election. Within this Whiggish framework, Jay’s aspirations as chief justice have been deduced not from reconstructions of his intellect but from the use made by nineteenth-century jurists of Jay Court decisions. Historians imply, in other words, that Jay must have intended to lay foundations for whatever the high court finally became, and failed miserably. Robert Mc-Closkey, for instance, compares the Court before 1801 to a “play’s opening moments with minor characters exchanging trivialities,” candidly conceding that the “great shadow of John Marshall . . . falls across our understanding.” Charles Haines once pointed to “unpromising beginnings”; a classic textbook treats the years before Marshall’s arrival in four pages. And Morris basically employs the same yardstick, arguing success and doctrinal kindredness in the place of failure and pale imitation. Had Jay accepted John Adams’s invitation to return to the Court in 1801, he concludes, Marshall’s finest state papers “would very probably have been written by Jay, whose views Marshall so completely shared.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "iench26"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench26"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Yet John Jay’s views were entirely his own, molded before all else by the exigencies of revolution. When Washington signed Jay’s commission as chief justice of the United States in September 1789, the republic was situated differently and more precariously than it would be a dozen years later. Economic distress seemed to portend the nation’s early demise, especially in competition with deeply skeptical European empires. A theoretically promising frame of government was untried; vague constitutional language surrounding the Court’s role in governance—made more explosive with the addition of contested sections in the 1789 Judiciary and Process Acts—invited Anti-Federalists to dismantle what Washington called the “keystone” of federalism."), _c('sup', [_c('a', {
    attrs: {
      "id": "iench27"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench27"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Indeed, criticisms often seem to be well founded. Before 1795, the Supreme Court’s caseload was thin, its members frustrated and disconsolate, and what Jay called its “Facilities of usage and Habit” mostly unspecified. Without immediate institutional antecedents, the entire federal judiciary lacked legitimacy and came to be humiliated all too easily by congressional adoption of the punitive Eleventh Amendment in 1798."), _c('sup', [_c('a', {
    attrs: {
      "id": "iench28"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench28"
    }
  }, [_vm._v("8")])]), _vm._v(" The chief justice, moreover, has been dismissed as a “trifling” student of domestic law whose court escaped mediocrity (when it did) largely because James Wilson and other imaginative associates shared the bench. Again, when measured against modern standards, such charges seem plausible. Jay produced no scholarship "), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _vm._v("more extensive than grand jury charges and brief "), _c('em', [_vm._v("Federalist")]), _vm._v(" essays. His apprenticeship and private practice were relatively insubstantial, and his judicial experience in New York before 1789 was fleeting."), _c('sup', [_c('a', {
    attrs: {
      "id": "iench29"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench29"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But appearances mislead. Jay’s vision of the Supreme Court’s role in government differed in several respects from modern conceptions of the institution’s role in federated government. This is exactly as it ought to be. Unlike Marshall, Jay superintended a wholly untested judiciary, supported only in part by colonial antecedents. His chief justiceship, moreover, coincided with a particularly volatile phase of revolutionary process—the period immediately after formal adoption of a contested (some thought illegal) frame of government. In addition, Jay’s intellectual and professional inclinations, while well suited to the day and to his own conception of judicial responsibility, were sweepingly internationalist (in Morris’s view, “continental”)"), _c('sup', [_c('a', {
    attrs: {
      "id": "iench210"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench210"
    }
  }, [_vm._v("10")])]), _vm._v(" rather than inward turning or provincial, philosophic rather than lawyerly, organic and hegemonic rather than mechanical and pluralist. Within his elegant, symmetry-seeking intellectual “system,” Jay merged High Federalist legalism and political conservatism with free-trading economic liberalism; for this rigidly principled man, and for many of his friends, conservative republicanism and Smithian political economy coexisted quite peaceably, bound together by an encompassing framework of moralizing, stabilizing public law. This collection of unfamiliar associations surely represents not a watered-down prelude to grandeur but an "), _c('em', [_vm._v("alternative")]), _vm._v(" jurisprudential scheme bound up tightly in the reality of an unfinished, highly unstable revolution.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('em', [_vm._v("The Road to Reluctant Patriotism")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("John Jay’s youth prefigured the man. The eldest son of the wealthy Peter and Mary Van Cortlandt Jay, whose ancestry was partly Huguenot, John followed the path dictated by his parents’ lofty position within the New York mercantile community. After private tutoring, he entered King’s College (now Columbia University) to study the classics, natural science, public law, philosophy, and political economy. Jay came to the law in his final year at the college, and then (as was customary among gentlemen) primarily as preparation for public service. He graduated with honors and took up an apprenticeship (again, as was customary) with the eminent New York City attorney "), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _vm._v("Benjamin Kissam; as assistant to chief clerk Lindley Murray, he soon chafed under piles of tedious copy work. When city lawyers struck in support of the Stamp Act protest in 1765, Jay happily fled to the family estate in Rye, New York. There, he buried himself in philosophy, public law, and the classics; two years later, King’s College rewarded these efforts with a master of arts degree.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By all reports, Jay was a successful lawyer. In 1766, two years after his return to Kissam’s office, he gained admission to the New York bar and opened a New York City law office with his schoolmate Robert Livingston, Jr. Jay leavened work with upper-class diversions: debating clubs, the exclusive Dancing Assembly, and conservative state political groups. In 1769, he accepted his first public office as a commissioner charged with settling a New York-New Jersey boundary dispute; five years later, Jay’s bright professional and social prospects allowed marriage to the wellborn Sarah (or Sally) Van Brugh Livingston.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But, even as the couple exchanged vows, American cities rumbled with rebellious talk about the Intolerable Acts and George Ill’s abrogations of his coronation oath. Jay initially resisted independence; he helped formulate the conciliatory Olive Branch Petition of 1774 and seriously considered expatriation as an alternative to treason. But, by 1775, the ever-louder transatlantic screaming match about both the constitutional status of the colonies and the merits of an Anglo-American economic partnership exerted a powerful attraction. Jay, after all, held advanced degrees in political economy and public law, including the law of nations; he feared, too, that the crown no longer could protect colonial trade and property. Intellectual challenges aside, familial and class interests—responsible only in part for Jay’s nervousness about imminent public disorder"), _c('sup', [_c('a', {
    attrs: {
      "id": "iench211"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench211"
    }
  }, [_vm._v("11")])]), _vm._v("—led him to remain in the New World.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jay served the cause initially in state political groups and then in the First and Second Continental Congresses. For the moment, he suspended his half-buried Calvinism and deep-seated skepticism about republican faith in voluntarism and perfectibility: perhaps Americans "), _c('em', [_vm._v("were")]), _vm._v(" capable of self-government. During these tumultuous years, he even parted ways occasionally with moderating colleagues in the New York congressional delegation: his championship of the Galloway Plan for colonial economic unification, for instance, as well as his strident support for nonimportation agreements as a member of New "), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _vm._v("York’s radical Committee of Sixty, set him sharply apart from many of his friends. At the same time, he sat on state Committees of Correspondence and Safety, synchronizing intracolonial protests and providing a semblance of government as the British magistracy collapsed. Jay helped draft the New York state constitution; until 1779, he also served (erratically and without distinction) as chief justice of the New York superior court. Only a few days after he arrived in Philadelphia to serve as a New York delegate to the general government, members of the new Congress elected Jay president of that body. Shortly afterward, he became minister plenipotentiary to Spain; a scant three years later, he went to Europe with four other commissioners to negotiate what would become the Paris Peace Treaty with Great Britain.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("These were traumatic experiences. Almost at once, Jay concluded that his original, gloomy assessment of the republican character—and, more generally, American prospects for success within a decentralized confederation—had been appallingly accurate. As a weak quasi-executive in Congress, Jay helplessly presided over what he took to be the disintegration of the confederation. Where other men saw growing pains, Jay perceived moral decay and the loss of security in liberty. Americans engaged in the invention of modern political parties and in a celebration of nascent capitalism were entirely aware of the divisive, self-interested quality of their activities; Clintonians and other “modern men” regularly pointed to an emerging polity and economy accessible to Everyman. Jay detected what Gordon Wood might call an “assault on aristocracy”"), _c('sup', [_c('a', {
    attrs: {
      "id": "iench212"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench212"
    }
  }, [_vm._v("12")])]), _vm._v(" and its traditional monopoly of public culture. Everywhere, republicans seemed to embrace or tolerate moral degeneracy, demagoguery, disdain for law, extreme “levelling,” disastrous logjams in Congress, the fettering of diplomats, drifts of worthless paper currency, and tooth-and-nail competition among the states for trading privileges. In Europe, Jay personally guaranteed repayment of war loans; privately, he despaired of society’s capacity for virtue and Congress’s ability to navigate the rapids between independence and nationhood. How could diplomats persuade Europeans of republican integrity, he wondered, when the people’s representatives embraced ignoble, self-destructive practices and policies?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thus, scholars have ample ground to contend that Jay, well before the ink dried on the Judiciary and Process Acts, steadily rowed against the republican current, or at least against the democratizing, socially "), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _vm._v("transformative part of that current. Jay was keenly aware of instabilities lurking in those “soft ambiguous moments”"), _c('sup', [_c('a', {
    attrs: {
      "id": "iench213"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench213"
    }
  }, [_vm._v("13")])]), _vm._v(" after ratification. In his own words, the problem at hand was to discover, within legal and political limits, how the new federal judiciary—and especially the Supreme Court—might best provide “due support to the national government” in pursuit of “great and obvious principles of sound policy.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "iench214"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench214"
    }
  }, [_vm._v("14")])]), _vm._v(" Because the main task was "), _c('em', [_vm._v("establishment")]), _vm._v(" rather than expansion or innovation, Jay’s understanding of such terms as “due support” or “great and obvious principles” merits close attention. How did he imagine proper relations between polity, economy, and law? Toward what ends did the new federal government move, and through whom? How might the high court advance those ends most effectively?")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('em', [_vm._v("Jay’s Political Economy and Jurisprudence in the Crucible of Revolution")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Jay’s political and jurisprudential “system” blended an extremely conservative domestic politics with liberal economic theory, the latter very narrowly construed. With Adam Smith and other political economists, Jay conceived of liberalism primarily as a blueprint for stable, global commercial development, predicated upon the existence of moral domestic societies in advance of economic exchange."), _c('sup', [_c('a', {
    attrs: {
      "id": "iench215"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench215"
    }
  }, [_vm._v("15")])]), _vm._v(" He also distinguished between political citizenship as defined by individual nations and the broader, more significant membership of Americans and Europeans in a transnational economic community. To facilitate the emergence of a harmonious “band of brethren” in North America, Jay urged internal centralization, reliance upon a few enlightened statesmen, and strict attention to federal law—the embodiment of reason and divine morality—in order to secure both forms of citizenship against the evils inherent in all people. Without these safeguards, Jay predicted swift decline into the immorality and greed so “natural” in human societies."), _c('sup', [_c('a', {
    attrs: {
      "id": "iench216"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench216"
    }
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Imbedded in Jay’s political thought was a stinging critique of the basic tenets of Revolutionary idealism. These disagreements, which Jay pressed steadfastly from the Revolution’s earliest moments through retirement, originated in an unusually bleak and remarkably static assessment of human nature. His expressions of doubt about "), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _vm._v("perfectibility, and then about the merits of voluntarism or adherence to the popular will, vacillated between moderation and stridency with changing circumstances. During “Seasons of general Heat Tumult and Fermentation” such as wartime or diplomatic crises, his anxieties intensified; his views softened appreciably with the prospect of a strengthened “national Head” after 1787. But shifting colorations barely masked an essential, unremitting gloom about the motives of politicized Americans and about “democratical” experimentation in an untutored postcolonial society wrenched too suddenly—that is, in violation of the laws of natural social development—from British imperial moorings."), _c('sup', [_c('a', {
    attrs: {
      "id": "iench217"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench217"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jay’s existential depression flowed partly from pietism. A devoted Anglican, he nevertheless remained conscious for a lifetime of his family’s Huguenot origins; indeed, his notorious admiration of Great Britain reflected considerable gratitude that his forebears had been provided “an Assylum.” Old Testament and apocalyptic imagery punctuated his prose, alongside pointed analogies between public and private salvation or states of grace. Jay also participated actively in religious and antislavery societies, for the persistence of slavery—an “inconsistent . . . unjust and, perhaps, impious” blemish upon supposed libertarians—powerfully reinforced the conviction that civic virtue could only be “drawn to a point,” after which improvement was unlikely."), _c('sup', [_c('a', {
    attrs: {
      "id": "iench218"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench218"
    }
  }, [_vm._v("18")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Only a handful escaped Jay’s obloquy, and common folk, to whom he frequently imputed bestial qualities, were the least favored of all. As early as 1777, he had been alarmed by a potentially savage “Public,” admonishing his friend Gouverneur Morris to send soothing “Paragraphs” to colleagues serving on the New York Council of Safety for mass distribution: “The People suspect the worst [when] ... we say Nothing. Their Curiosity must be constantly gratified, or they will be uneasy.” Similarly, Jay admired Pennsylvania’s experiments with manufactures to alleviate unemployment and unrest, on the ground that bread and abundant work might keep ordinary citizens “easy and Quiet.” When “Fellow Mortals are busy and well fed,” Jay theorized, “they forget to complain.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "iench219"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench219"
    }
  }, [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By the mid-1790s, Jay had dispensed with rhetorical caution. Steely resignation replaced the relatively benign assertion that man was a “degraded creature,” or that humankind was guided more by “conveniences than by principles.” No longer would he entertain fantasies "), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _vm._v("about an “age of reason, prior to the millennium”; nor would he “believe one word of” the “modern” suggestion that appetite could be subordinated to “right reason.” In 1797, Jay was consoled by the knowledge that “every scourge of every kind by which nations are punished”—perhaps the same “Evils inseparable from Humanity” identified some twenty years before—were under the “control of a wise and benevolent Sovereign.” When Judge Peters hinted in 1815 that the people always meant well, Jay wasted little ink: “The word "), _c('em', [_vm._v("people")]), _vm._v(", you know, applies to all the individual inhabitants of a country.” The portion that “mean well never was, nor until the millennium will be, considerable.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "iench220"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench220"
    }
  }, [_vm._v("20")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Also by the mid-1790s, Jay routinely divided the polity into “Politicians” and “Citizens.” The former encompassed legislative demagogues, “pharisaical patriots,” and the “lower Class of Mankind” who blindly followed these charlatans toward Jacobinism."), _c('sup', [_c('a', {
    attrs: {
      "id": "iench221"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench221"
    }
  }, [_vm._v("21")])]), _vm._v(" “Citizens,” on the other hand, included sober, contemplative statesmen who refused to contrive “a shoe that would fit every foot,” as well as that small portion of the electorate with courage enough to support them. Virtue was inborn: some men possessed it from birth, others did not. And those who did not sometimes pretended otherwise, posing as statesmen in legislative chambers. Jay’s conclusions were essentially genetic: the “improper arts” of assemblymen reflected the fact that “creatures will act according to their nature, and it would be absurd to expect that a man who is not upright, will act like one who is.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "iench222"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench222"
    }
  }, [_vm._v("22")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With politicians, Jay was unsparing. These were “men raised from low Degrees . . . rendered giddy by Elevation,” who typically consulted “prevailing fashions” rather than “the utility of their goods to those who are to wear them.” Worse, pernicious “levelling principles” and self-serving campaign promises spawned violence after the French example. Jay therefore hoped to circumscribe the influence of “men without Character [or] Fortune” until virtue had been disseminated more broadly through education and exposure to law, or until a centralized government might be perfected."), _c('sup', [_c('a', {
    attrs: {
      "id": "iench223"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench223"
    }
  }, [_vm._v("23")])]), _vm._v(" With the possibility of a new Constitution after 1787, Jay speculated about gradual improvement among politicians over several generations. Ultimately, however, he resigned himself to a succession of barbarians whose “artifices,” pandering, and “irascible passions” would be contained for a time through the “strenuous efforts of the wise.” Only in another world "), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _vm._v("might “all books and histories and errors ... be consumed,” and “truth . . . rise and prevail and be immortal.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "iench224"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench224"
    }
  }, [_vm._v("24")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Unfortunately, wisdom was a scarce resource, and typically the special province of executives or jurists who came to office without popular election. Jay associated political debts and localism with incompetence: the further removed a man might be from his constituency, the less likely corruption or pettiness. The fact of election thus aroused the New Yorker’s suspicions, while nomination assuaged them; and federal appointees were less tainted and more gifted than their counterparts in the states by virtue of selection from an expanded pool. It followed that the general government would be “more wise, systematical, and judicious” than local governments, for there would be no “want of proper persons.” Unsullied by the "), _c('em', [_vm._v("“necessity of the Case,”")]), _vm._v(" this self-selecting “elect” somehow had to retain what Edward Rutledge called “the Staff until Americans demonstrated “whether they could govern themselves.” At stake was republican survival, and Jay was worried. The same sensitivities that separated the wise from mere politicians also encouraged disillusionment in the face of public abuse, for the “Residue,” as Jay dubbed the majority, rarely mustered “Honesty or Spirit enough openly to defend unpopular Merit,” thereby routing talented but weary statesmen."), _c('sup', [_c('a', {
    attrs: {
      "id": "iench225"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench225"
    }
  }, [_vm._v("25")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("From this pessimistic bedrock, Jay’s posture toward Britain and his restrictive domestic politics followed logically and inexorably. In fact, both were little more than an elaboration of a favorite maxim: “Fortitude founded on Resignation.” His reluctant but diligent patriotism, for example, originated less in a firm preference for independence than in perceptions of an intractable emergency in political economy. Jay had preferred British citizenship at least through 1775, despite serious misgivings about the empire’s performance. His shift to the cause, while facilitated by deeper association through marriage with the Livingston family, crystallized primarily with mounting evidence of the crown’s inability to protect distant property and to guarantee trade—the “great and weighty reasons” underlying all political unions."), _c('sup', [_c('a', {
    attrs: {
      "id": "iench226"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench226"
    }
  }, [_vm._v("26")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Yet these decisions did not alter Jay’s fascination with British civilization or with imperial governance. While drafting the Olive Branch Petition, he yearned for a speedy restoration of peace without “further Effusion of Blood,” confessing that he would be “hurt” by the destruction of England and by loss of access to “the Prosperity of the "), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _vm._v("Empire now rent by unnatural Convulsions.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "iench227"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench227"
    }
  }, [_vm._v("27")])]), _vm._v(" A decade after independence, he still urged Americans to preserve cultural and trading channels established during long centuries of British tutelage. The crown’s ability to suppress provincial violence through centralization fascinated him,"), _c('sup', [_c('a', {
    attrs: {
      "id": "iench228"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench228"
    }
  }, [_vm._v("28")])]), _vm._v(" and he fretted constantly about exclusion from the world’s most extensive commercial network, eagerly anticipating a “liberal Alliance” with Londoners. The rebellion and its stormy aftermath, he thought, were unseemly escalations of a necessary squabble between parent and talented child. Even in the throes of war, Jay contemplated a return to British domination “with Horror” and would “risque all for Independence”; but that point settled, he encouraged the swift extension of “advantageous commercial Terms.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "iench229"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench229"
    }
  }, [_vm._v("29")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Years later, John Adams complained that the Revolution had not been sustained by “such characters” as Jay and the Morrises—those irksome New Yorkers who castigated the public’s potential for “virtue” and so cast doubt upon the Revolution’s main engines. He was both right and wrong. Jay certainly deplored the creation of a decentralized commonwealth guided by unfettered congressional “politicians” and by emasculated executive departments—a structure dangerously dependent upon the “public” metamorphosing instantly into “citizens.” He detected mischief in the notion that most Americans would sacrifice short-term gain for the greater good, and more than a little French romance in “levelling.” More important, he dreaded the construction of an isolated, introverted new imperial economy, tied fatally to collective decision making and to an unrealizable, undesirable self-sufficiency."), _c('sup', [_c('a', {
    attrs: {
      "id": "iench230"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench230"
    }
  }, [_vm._v("30")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In short, while Jay disagreed with most of the assumptions and strategies propelling Revolutionary politics, he did not reject the possibility that independent republican citizens might behave virtuously. He denied only the universality of virtue in the “Public” and thus its reflection in the minds and labors of legislators. In Jay’s estimation, virtue resided mainly in a very few statesmen then held in check by the new Congress, which dramatically reduced its value to society. Criticisms were urgent: if pie-eyed republican schemes prevailed, unity and prosperity—the fundamental “objects” of nationhood—would be sabotaged."), _c('sup', [_c('a', {
    attrs: {
      "id": "iench231"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench231"
    }
  }, [_vm._v("31")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jay’s “first wish” for the new nation was domestic unification—an internal, primarily political object. Unity was basic and altogether critical; without it, property and persons might never be secure. At the "), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _vm._v("same time, unity was only a first step onto the world stage, and so a penultimate object en route to Jay’s ultimate goal: prosperity. Jay knew that a disunited nation would be denied membership in a global community, having failed to achieve the “character of ONE GREAT NATION.” And the structure best suited to unity’s achievement and maintenance, given republican imperfections, was a “strong government” of decisive federal institutions and laws “ably administered” by a wise minority."), _c('sup', [_c('a', {
    attrs: {
      "id": "iench232"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench232"
    }
  }, [_vm._v("32")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("These sentiments emerged as early as 1776 in response to wartime disorders: the need for “good and well ordered Governments” to prevent “that Anarchy which already too much prevails,” he told Alexander McDougall, must be “inculcated.” But “Anarchy” persisted after independence; and the Confederacy, Jay feared, was a sorry plan indeed. In 1777, he allowed only that the general government “augurs well,” wanly conceding that an indifferent constitution was “better than none.” As atomization seemed to continue, Jay’s anxieties proliferated. He began to calculate the odds for and against complete collapse, grimly anticipating which “Parties and Factions will arise, to what Objects be directed, . . . and who will be the victims.” His frustrations deepened appreciably while negotiating the peace for an unhelpful Congress and as secretary for foreign affairs after 1783. Chaos at home plainly threatened the safety and tranquility of New World citizens. But it also marked republicans as unreliable and violent. The mark of Cain, in turn, introduced untenable disadvantages in dealings with Europeans, with whom Americans were obliged to compete on the high seas, and from whom the republic absolutely required grants of respect and legal standing."), _c('sup', [_c('a', {
    attrs: {
      "id": "iench233"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench233"
    }
  }, [_vm._v("33")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This fresh awareness of diplomatic complexity, combined with Jay’s considerable disdain for legislators, soon produced brutal denunciations of congressional bickering and immobilization. The secretary’s complaints were legion: he decried the states’ “impatience of government,” which encompassed local resistance to congressional taxation; an insatiable rage for property in the face of national hardship; and a reckless “desire of equality in all things.” Jay also deplored government’s failure to prevent Indian attacks, chronic absenteeism in Congress, procrastination over debts, and the absence of a “continental, national spirit.” Pointing to an empty treasury “though the country abounds in resources,” he bemoaned “disappointment to our creditors [and] disgrace to our country”—conditions that spoke to the "), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _vm._v("“want of good government to guard good faith and punish violations.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "iench234"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench234"
    }
  }, [_vm._v("34")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The origins of public apathy toward unification, Jay argued in 1788, were cultural. Americans had agreed to a confederation more “paternal and persuasive than coersive and efficient” after centuries of colonial dependency, during which affairs of state such as war, peace, and commerce had been “managed for us and not by us.” Republicans therefore responded to crisis times with passivity and ignorance. What might be done? Durable unification, Jay explained, typically proceeded from “constitutional coersion, or . . . the dictates of reason.” The former was unavailable, and Americans in their present condition were deaf to reason. Stopgap strategies seemed equally futile: even a unifying war would be lost at the hands of congressmen whose honor and authority decayed almost daily. Within this “wonderful system of government,” Jay told fellow New Yorkers, “almost every national object. . . [is] unprovided for.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "iench235"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench235"
    }
  }, [_vm._v("35")])]), _vm._v(" The secretary sensed “some crisis”; he was “uneasy and apprehensive; more so than during the war.” And Shays’s Rebellion was a terrifying omen: “The insurrection in Massachusetts is suppressed,” he fussed, “but the spirit of it exists.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "iench236"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench236"
    }
  }, [_vm._v("36")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jay toyed with the idea of constitutional reform—a grant of necessary powers so that Congress might better regulate commerce and “general concerns”—but quickly fastened upon a more drastic remedy. Unification, as well as the liberation of the nation’s “ablest men” from legislative constraints, could not be achieved within a defective frame of government; no amount of tinkering would save the day. The single most glaring defect was the “great mistake” of a multifunctional Congress bent upon reducing “big men into little ones.” Powers to make and execute law, Jay admonished Jefferson, should never be vested in “one and the same body of men,” not only because confusion would eventuate but also because legislators could hide behind one another. Whenever assemblies divide “blame and credit,” he explained, “too little falls on each man.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "iench237"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench237"
    }
  }, [_vm._v("37")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nor should a reorganized Congress be granted decisive power in pursuit of crucial “objects of state.” In 1776, Edward Rutledge wanted to allow “no more Power than what’s absolutely necessary” in order to retain executive autonomy; Jay pursued the same strategy in a different context. Otherwise, he later explained, the “executive business of sovereignty” would be “but feebly done.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "iench238"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench238"
    }
  }, [_vm._v("38")])]), _vm._v(" With other "), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _vm._v("Federalists, Jay recommended a departmental system of government composed of three formal branches. Quite separately, though, he imagined two competing blocs of power—an informal coalition of executives and judges pitted against legislative excess. Laws then would be “expounded in one sense and executed in the same manner,” allowing the United States to move along “uniform principles of policy.” Collaborators, in other words, could “harmonize, assimilate, and protect the several parts,” guaranteeing “mutual participation in commerce, navigation, and citizenship.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "iench239"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench239"
    }
  }, [_vm._v("39")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For Jay and other High Federalists, anarchical decay was far more likely than despotism or ministerial tyranny; indeed, he might have welcomed a parliamentary arrangement with properly autonomous ministries. Jay may well have associated executive license with royal prerogative, and modeled his informal alliance after customary relations between the King-in-Parliament and the courts at Westminster; whatever the case might be, he lacked the patience and taste for further experimentation, particularly with legislators at the helm. “The most perfect Constitutions, the best Governments, and the wisest Laws are vain,” Jay told grand jurymen in 1790, “unless well administered and well obeyed.” Time and again, Jay made clear, often in tropes borrowed from English law practice, that adherence to the rule of law ensured freedom: fidelity to law was not “unfriendly to Liberty,” or at least to “that Liberty which is really inestimable. [O]n the Contrary, nothing but a strong Government of Laws, irresistably bearing down arbitrary power & Licenciousness can defend it against those two formidable Enemies. Let it be remembered,” he added for good measure,")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("that civil Liberty consists not in a Right to every Man to do just what he pleases—but it consists in an equal Right to all the Citizens to have, enjoy, and to do, in peace Security and without Molestation, whatever the equal and constitutional laws . . . admit to be consistent with the public Good.")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("A scant three years later, in the emergency atmosphere accompanying Washington’s Neutrality Proclamation, Jay made the point a bit differently, contending that reliance upon law necessarily increased when men claimed extraordinary freedom.")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("The more free the people are, the more strong and efficient ought their Governm[en]t to be; and for this plain Reason, that it is a more arduous Task "), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _vm._v("to make and keep up the Fences of Law & Justice about twenty Rights than about five or six; because it is more difficult to fence against & restrain men who are unfettered, than men who are in Yokes & Chains."), _c('sup', [_c('a', {
    attrs: {
      "id": "iench240"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench240"
    }
  }, [_vm._v("40")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Jay augmented this judge-led, law-bound “balance of power” against popular and congressional licentiousness with harsh circumscription of state power—a scheme reminiscent of the old New Jersey Plan."), _c('sup', [_c('a', {
    attrs: {
      "id": "iench241"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench241"
    }
  }, [_vm._v("41")])]), _vm._v(" Again inspired by British practice, Jay conceived of the states as extraordinarily weak administrative fictions existing at federal pleasure. As he told Adams, “I would have them [states] considered . . . in the same light in which counties stand to the States,” as constitutionally dependent “districts to facilitate the purposes of domestic order and good government.” Adamantly opposed to the creation of new states—whether through subdivision or in frontier areas where “white savages” compared unfavorably with “tawny ones”—Jay even recommended that key state officials be nominated by the general government. These choices spoke to law enforcement that, he thought, would not “always accord or be consistent” without strength at the center, as much from the “variety of independent courts” as from “different local laws and interests.” Jay similarly applauded the construction of centralized courts as a hedge against “[l]aws dictated by the Spirit of the Times not the Spirit of Justice.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "iench242"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench242"
    }
  }, [_vm._v("42")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Zeal for constitutional revision (and for expanded prerogative powers for agents of the executive branch) increased dramatically wherever Jay perceived a threat to diplomatic efforts. Prosperity—his ultimate “object of state”—required confrontations with ancient, well-defended imperial powers, and successful interaction was doomed, he knew, without at least the appearance of internal harmony. Jay was obsessed with Congress’s dubious respectability in Europe and persuaded as well that circumstances could only deteriorate, for experienced mercantilists were not obliged to deal with upstart republicans inhabiting an unstable polity. Jay feared that Americans would soon wave “FAREWELL, A LONG FAREWELL” to unrealized prosperity, and that friendly nations then willing to embrace a “great and powerful” America would be forced to retreat. “Whatever may be our situation,” he warned in a "), _c('em', [_vm._v("Federalist")]), _vm._v(" essay, “whether firmly united ... or split into a number of confederacies, certain it is, that foreign nations will know and view it exactly as it is; and they will act towards us accordingly[.]”")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _vm._v("If they see that our national government is efficient and well regulated . . . our resources and finances discreetly managed—our credit re-established—our people . . . united, they will be much more disposed to cultivate our friendship. . . .[I]f they find us destitute of an effectual government... what a poor, pitiful figure will America make in their eyes!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("And, when he finally addressed republican grand juries on the Eastern Circuit in 1790, Jay hammered away—rather obsessively, given the nature of the cases pending—at the perils of bad faith in foreign affairs, notably (but not only) in meeting treaty obligations."), _c('sup', [_c('a', {
    attrs: {
      "id": "iench243"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench243"
    }
  }, [_vm._v("43")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("These preoccupations reflected Jay’s unhappy years as a diplomatstatesman. While laboring after 1781 to secure peace with Britain, he had been nettled and occasionally mortified by Congress’s poor credit and shoddy intelligence procedures, but his exertions in the foreign affairs office between 1783 and 1789 were frustrated more directly and constantly."), _c('sup', [_c('a', {
    attrs: {
      "id": "iench244"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench244"
    }
  }, [_vm._v("44")])]), _vm._v(" International agreements, he insisted, should be negotiated only by private statesmen guided by conscience and by the sterling principles of international law. “Large assemblies,” said Jay, “often misunderstand . . . the obligations of character, honour, and dignity, and will collectively do or omit things which individual gentlemen in private capacities would not approve.” Congress was public, raucous, and sluggish; diplomacy required discretion and “immediate despatch.” And transient lawmakers were ill qualified for the “attainment of those great objects” that had to be “steadily contemplated in all their relations and circumstances.” To relegate foreign policy to petty politicians hounded by voters and limited by their own character was to court economic and diplomatic disaster. On one occasion, Jay sarcastically announced that, if forced to choose, he preferred the “Enterprise, Activity and Industry of private Adventurers” to the “Lukewarmness of Assemblies,” for “Public Virtue” was “not so active as private Love of Gain.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "iench245"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench245"
    }
  }, [_vm._v("45")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The term “lukewarmness” captured several complaints about legislative lassitude, the majority’s unaccountable fascination with disclosure, and the myopic quality of congressional economic policy. It mattered little whether shortcomings flowed from human frailties or the clumsiness of political process; Europeans saw only the consequences and would be alienated accordingly. Here, Jay again offered pointed analogies between public and private morality. Fraud, rudeness, and insolence, he counseled, would not only "), _c('em', [_vm._v("“degrade")]), _vm._v(" and "), _c('em', [_vm._v("disgrace")]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _vm._v(" nations & Individuals, but also "), _c('em', [_vm._v("expose")]), _vm._v(" them to Hostility & insult.” National “indiscretions,” he wrote in an uncommonly frank jury-charge draft, “have given Occasion to many Wars.” On the other side, fair dealing and a harmonious polity encouraged peace and prosperity. Indeed, among the just causes of war, Jay listed treaty violations, which he associated with French influence, craven state governments, and, by 1795, indebted speculators who preferred “spoil and plunder” to “patient industry and honest gains.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "iench246"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench246"
    }
  }, [_vm._v("46")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jay particularly fulminated against violations of the Definitive Treaty with Britain and of the compacts supporting Revolutionary War debts. His own promises underpinned many such agreements. Of greater moment, however, were national “honour, justice, and interest.” Time and again, he advocated broader powers of “coersion” so that administrators and judges might enforce these “most salutary and constitutional objects.” Jay also pleaded for a moratorium upon new loans until old debts had been cleared. He chided Congress for its inattention to the obligations of nationhood, as opposed to the more pleasurable rights and privileges."), _c('sup', [_c('a', {
    attrs: {
      "id": "iench247"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench247"
    }
  }, [_vm._v("47")])]), _vm._v(" With Washington, he suspected that disadvantageous political entanglements flowed inevitably from dependence upon the “charity of our friends” and the “mercy of our enemies”; in 1793, he feared as well that the “Man or the Nation who eludes the payment of Debts, ceases to be worthy of further Credit.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "iench248"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench248"
    }
  }, [_vm._v("48")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If lingering debts threatened healthy relations with the French and Dutch, violations of the Paris Peace Treaty directly affected an Anglo-American rapprochement. The president’s alarm paralleled Jay’s: “If you tell the Legislature they have violated the treaty of peace,” he wrote, “they will laugh in your face. What, then, is to be done?” Jay chose moral and political instruction. Treaties, he said in various ways, were “only another name for a bargain.” State evasions of lawful debts had not surprised Jay. As early as 1783, he predicted that designing debtors would try to undermine the treaty’s unpopular fourth article, which promised payment for wartime contracts or confiscations of Loyalist property. But continued belligerence now partook “more of vengeance than of justice,” Jay argued, fattening state coffers at the expense of the nation’s long-term interests."), _c('sup', [_c('a', {
    attrs: {
      "id": "iench249"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench249"
    }
  }, [_vm._v("49")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jay therefore joined other Federalists in the struggle against obstructionism in the states, simultaneously apologizing to friends in Europe. In 1786, Lafayette learned of Congress’s regrettable disarray; Jay also assured Britain’s Lord Lansdowne, from whom Jay begged "), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _vm._v("abundant “good nature,” that constitutional lethargy and the lack of “temper and liberality” among republicans would be remedied swiftly by honorable men."), _c('sup', [_c('a', {
    attrs: {
      "id": "iench250"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench250"
    }
  }, [_vm._v("50")])]), _vm._v(" The secretary campaigned tirelessly against “discriminations inconsistent with the treaty of peace” through which worthy men had been deprived of citizenship and property. After 1789, these efforts continued from the bench. Repeating his warnings about obligations and duties, Chief Justice Jay admonished Americans to abide by “treaties Conventions, and the like compacts.” Just as “in private Life a fair and legal Contract between two Men, cannot be annulled nor altered by either without the Consent of the other, so neither can Treaties between Nations.” By 1794, he had begun to discourage British acquaintances from investments in American enterprise. New sequestration measures, he told them, theoretically were “improper” and therefore unlikely, but when pressed for assurances, he “declined to give any.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "iench251"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench251"
    }
  }, [_vm._v("51")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Stern exhortations about public morality, political harmony, and “effective Power” in the hands of statesmen coexisted with equally fervent pleas for liberalized trading relations. Jay’s prescription for the nation’s economy, which superficially resembled James Wilson’s Commonwealth of Nations fantasy,"), _c('sup', [_c('a', {
    attrs: {
      "id": "iench252"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench252"
    }
  }, [_vm._v("52")])]), _vm._v(" rested upon sophisticated, shrewd analyses of the strategic weaknesses of the United States and of its “natural wealth, value, and resources.” Economic success seemed to depend entirely upon “breaking] the ice” with England. With Wilson, Adams, and others, Jay envisioned a “base system”"), _c('sup', [_c('a', {
    attrs: {
      "id": "iench253"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench253"
    }
  }, [_vm._v("53")])]), _vm._v(" of reciprocal trade agreements—first with Britain’s competitors, whose friendship was strategically useful in the struggle against British mercantilism, if a limited avenue to great wealth, and then with England itself. Jay probably hoped, too, that public mobilization around the prospect of collective financial gain might spur unification, should political tactics fail."), _c('sup', [_c('a', {
    attrs: {
      "id": "iench254"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench254"
    }
  }, [_vm._v("54")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jay distinguished, then, between undesirable dependencies accompanying the status of debtor—which he dubbed “dependence for friendship,” and which necessitated a very dangerous form of gratitude—and mutual respect between autonomous trading partners. This healthy dependency was couched, not coincidentally, in the equalizing tropes of contract law. Jay clearly saw the republic’s glaring military and financial inequality; legal fiction shielded statesmen and traders alike, facilitating independence “in the most extensive sense.” Americans could be “honest and grateful to our allies,” Jay "), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _vm._v("noted wryly, “but . . . think for ourselves.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "iench255"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench255"
    }
  }, [_vm._v("55")])]), _vm._v(" Early agreements with France, Spain, or Russia served as a tempting carrot to dangle before the British crown while Americans exploited distant ports in relative safety. It was in the “interest of all Europe,” Jay advised the Spanish, to join republicans in “breaking down the exorbitant power” of an empire he openly lionized and just as plainly wished to befriend, cutting the “sinews” of British monopoly power while maximizing unequaled access to world markets."), _c('sup', [_c('a', {
    attrs: {
      "id": "iench256"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench256"
    }
  }, [_vm._v("56")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Well before the Paris peace, Jay had rejected the related notions of self-sufficiency and protectionism, perceiving that economic isolation and the mindless replication of an Old World empire provided false security. By 1783, these insights fed mounting concern and irritation. When Benjamin Vaughan and others resisted a “nugatory” reciprocity during the peace negotiations while also defending a favorable balance of trade for the British, Jay rather haplessly threatened an opposing navigation act. Two years later, his fears had not diminished. The English “expect much from the trade of America,” he wrote Adams, yet “put it out of our power to pay. ... I wish most sincerely that credit was at an end.” Reciprocity and direct exchange, he speculated, would defuse belligerence between nations with shared interests: “one cannot enrich herself without enriching the other,” creating a peaceable “natural connexion.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "iench257"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench257"
    }
  }, [_vm._v("57")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("These “connexions” further allowed an undercapitalized America to evolve industrial capacities, without contrivance or frenzy, on firm agrarian foundations. Jay distrusted “unnatural” preoccupations among Hamiltonians and others with domestic manufactures. Having laboriously calculated population increases, agricultural production, wage levels, and land availability in Europe and North America, he concluded, with many other economists,"), _c('sup', [_c('a', {
    attrs: {
      "id": "iench258"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench258"
    }
  }, [_vm._v("58")])]), _vm._v(" that the New World enjoyed significant advantages in agriculture that laborers recognized and would pursue. Hence, Jay foresaw several generations of small farmers primarily in an ever-expanding "), _c('em', [_vm._v("“Northern Hive”")]), _vm._v(" exchanging foodstuffs and other staples for capital-intensive European goods. “So great is the extent of country,” he expounded, “and so inviting to settlers, that labor will very long remain too dear to admit of considerable manufactures.”")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v(". . . [W]hen the poor . . . gain affluence by tilling the earth, they will refuse the scanty earnings which manufacturers . . . offer them. [Thus] exports "), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }), _vm._v("from America will consist of raw materials which other nations will [process] at a cheaper rate . . . [yielding for] the American States . . . "), _c('em', [_vm._v("actual wealth.")]), _c('sup', [_c('a', {
    attrs: {
      "id": "iench259"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench259"
    }
  }, [_vm._v("59")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Put differently, internal unification combined with “natural” agrarianism promised reconciliation with Britain and prosperity in the place of crippling indebtedness."), _c('sup', [_c('a', {
    attrs: {
      "id": "iench260"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench260"
    }
  }, [_vm._v("60")])]), _vm._v(" Jay’s correspondents in the Old Country frequently empathized. Lansdowne thought that his countrymen should be “deeply interested” in America’s “prosperity and reputation” and Jay heaped praise upon these “large and liberal views” that applied to the “future as well as the present . . . interests of the nation.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "iench261"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench261"
    }
  }, [_vm._v("61")])]), _vm._v(" Significantly, Jay also contemplated a universal “fellow citizenship” for republicans and Europeans alike, in the process elevating economic community over its political counterpart. How greatly would it “redound to the happiness as well as honour of all civilized people,” he suggested, “were they to consider and treat each other like fellow-citizens; each nation governing itself as it pleases, but each admitting others to a perfect freedom of commerce.” Toward that end, he cautioned Jefferson against perpetuating “ancient prejudice” in agreements with France—the “fencing” and “guarding” so characteristic of mercantilism—hoping instead that “all the commercial privileges” of Frenchmen might be exchanged for their American equivalents. From the vantage point of illegitimate revolutionaries, these were useful, canny suggestions. But they also betrayed Jay’s dogged internationalism—a frame of reference not shared entirely by proponents of a self-regenerating Fortress America."), _c('sup', [_c('a', {
    attrs: {
      "id": "iench262"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench262"
    }
  }, [_vm._v("62")])])]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('em', [_vm._v("The Supreme Court as Diplomatic and Moral Umpire")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("While awaiting Jefferson’s return from France in 1789, Jay served simultaneously as secretary of state and chief justice of the United States. This professional dualism was both circumstantial and characteristic, for Jay the jurist was primarily and inseparably a diplomatist. Historians of the Jay Court often decry these bifurcated interests and credentials, but Washington found them uniquely compatible with American needs and priorities in 1789."), _c('sup', [_c('a', {
    attrs: {
      "id": "iench263"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench263"
    }
  }, [_vm._v("63")])]), _vm._v(" From Jay’s point of view, the new Supreme Court seemed a peculiarly inviting forum for the cultivation of domestic unity, equitable trade relations, and a "), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }), _vm._v("working alliance between executives and judges. The chief justice’s experience and prejudices had convinced him that “nations and Individuals injure their essential Interests in proportion as they deviate from order.” He therefore eagerly pursued “form . . . strength order and harmony” (in 1793, he called it “national Regularity”) through rigorous exercise of the Court’s relatively uncontested original and exclusive jurisdictions. Few strategies held as much promise for the realization of a “due Distribution of Justice.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "iench264"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench264"
    }
  }, [_vm._v("64")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Before 1789, Jay had argued repeatedly that a “due Distribution” required cooperation between executives and jurists, whether through a council of revision, as in New York,"), _c('sup', [_c('a', {
    attrs: {
      "id": "iench265"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench265"
    }
  }, [_vm._v("65")])]), _vm._v(" or, to borrow George Washington’s term, through the well-orchestrated “Interpretation and Execution” of federal laws. Consultation surely strengthened the authority of a few good men against throngs of legislators, and coordination in advance of public action prevented potentially damaging impressions of indecision or disagreement in high places. But enlightened statesmanship for Jay also implied a certain freedom from structural constraints. The ends of governance, after all, transcended momentary political assignment; institutional attachments were vehicles toward those ends, not objects in themselves as legislators might have it. The autonomy of gentlemen-lawyers and executive agents therefore was essential, and their curtailment or confinement treacherous."), _c('sup', [_c('a', {
    attrs: {
      "id": "iench266"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench266"
    }
  }, [_vm._v("66")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For these reasons, Jay freely provided informal advice to kindred spirits throughout his federal judicial career while staunchly denying a formal advisory role for the Court itself. He also abruptly and freely abandoned the bench when he perceived that national “objects” were best pursued elsewhere. Jay’s advisory offerings ranged broadly, reflecting his eclectic expertise. In 1789 and 1790, for instance, Washington asked for assessments of the “real situation” in foreign affairs, the state of the judiciary, and general matters. Hamilton similarly requested and received advice on numerous subjects: congressional powers in Indian relations, trading rights, fortress and post-road construction, currency regulation, the legality of local commercial laws, and the propriety of an executive proclamation during Pennsylvania’s Whiskey Rebellion. On the other hand, Jay steadfastly refused to bulldoze formal boundaries between federal departments: in a 1792 New York circuit court hearing on a writ of mandamus in "), _c('em', [_vm._v("Hay burn’s Case")]), _vm._v(", to give the best-known example, he defended the separation of powers by refusing to allow federal courts to pass judgment, as an act of "), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }), _vm._v("Congress seemed to require, on claims of invalid pensioners; the decision (reinforced in 1794, to give one example among several, by suggestive language in "), _c('em', [_vm._v("Glass")]), _vm._v(" v. "), _c('em', [_vm._v("The Sloop Betsy)")]), _vm._v(" eased the way for later, strident attempts to claim an implied power to evaluate acts of Congress for constitutionality."), _c('sup', [_c('a', {
    attrs: {
      "id": "iench267"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench267"
    }
  }, [_vm._v("67")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jay’s decision to accept a special diplomatic assignment in 1794 capped several years of increasing frustration. The “essential interests” of the United States, as Jay defined them in 1793, coincided neatly with two aspects of federal law: the Constitution, case law, and acts of Congress that shaped “the Conduct of the Citizens relative to our own nation & people,” and the law of nations treating behavior “relative to foreign Nations & their Subjects.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "iench268"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench268"
    }
  }, [_vm._v("68")])]), _vm._v(" Indeed, without law’s presence, Jay could not have supported free trade. At every juncture, legal principle ordered and moralized an otherwise anarchic marketplace. The chief justice fixed his fondest hopes upon this convergence of object and federal jurisdiction. At long last, statesmen possessed formidable tools toward unification and prosperity—even without the more elusive, politically explosive implied review powers. Leaders could establish this new machinery with dispatch and move from strength thereafter; in Jay’s words, “Order usually succeeds Confusion” within adequate structures."), _c('sup', [_c('a', {
    attrs: {
      "id": "iench269"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench269"
    }
  }, [_vm._v("69")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Or so he hoped. Jay cautioned Hamilton against excessive force during the debt-assumption controversy: the less panic and noise, the better. Victory over unruly republicans demanded stealthy “exertion”; neither violence nor passive “reflection” would do. The federal plan, after all, mirrored the “design of Providence”; political heresy could be defeated legally and elegantly by simply enforcing new rules and shoring up contested or poorly articulated jurisdictions, including a federal common law of crime."), _c('sup', [_c('a', {
    attrs: {
      "id": "iench270"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench270"
    }
  }, [_vm._v("70")])]), _vm._v(" While riding circuit, Jay doggedly instructed untutored jurymen in the rudiments of citizenship and effective government. And he was heartened by early acquiescence to federal judicial authority in Rhode Island, New York, and elsewhere in scattered but politically charged disputes involving the Paris treaty and admiralty jurisdiction."), _c('sup', [_c('a', {
    attrs: {
      "id": "iench271"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench271"
    }
  }, [_vm._v("71")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A direct statement about the subordination of states to the nation, however, awaited the Jay Court’s confrontation with Georgia after 1792 in the fateful "), _c('em', [_vm._v("Chisholm")]), _vm._v(" v. "), _c('em', [_vm._v("Georgia.")]), _vm._v(" The circumstances underlying the debacle are well known: Chisholm, a Carolinian and the executor of one Farquhar, sought state performance of a Revolutionary "), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }), _vm._v("War contract through the Court’s original diversity jurisdiction—that is, the jurisdiction granted federal courts whenever noncitizens sued states. And Georgia returned the summons, claiming sovereign immunity from federal process. Unfortunately, the concept of state suability in federal courts was no less controversial in 1792-1793 than it had been before passage of the 1789 Judiciary Act."), _c('sup', [_c('a', {
    attrs: {
      "id": "iench272"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench272"
    }
  }, [_vm._v("72")])]), _vm._v(" On its face, the situation plainly addressed whether Jay’s “first wish” might be achieved through federal law: if “national Regularity” resulted from “Attention and Obedience to those Rules and principles of Conduct which Reason indicates and which Morality and Wisdom prescribe,” then Georgia’s refusal to appear subverted Jay’s plan for unification spearheaded by federal executives and judges."), _c('sup', [_c('a', {
    attrs: {
      "id": "iench273"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench273"
    }
  }, [_vm._v("73")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jay’s associates behaved predictably. All except James Iredell confirmed Georgia’s subordination to the nation, declaring the venerable doctrine of sovereign immunity inappropriate in a republic. With James Wilson, Attorney General Edmund Randolph articulated a vision of the states as administrative fictions that coincided almost perfectly with Jay’s sentiments. In a curiously wistful, nonlegalistic opinion, the chief justice had only to agree. Said Randolph, the United States was no longer a “Government of supplication”; and the states, given increased national “energy,” were merely “assemblages of . . . individuals” liable to process and to “diminutions of sovereignty, at least equal to the making of them defendants.” Would not the nation be useless if a “pleasure to obey or transgress with impunity should be substituted in the place of . . . laws”?"), _c('sup', [_c('a', {
    attrs: {
      "id": "iench274"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench274"
    }
  }, [_vm._v("74")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But, for Jay, "), _c('em', [_vm._v("Chisholm’s")]), _vm._v(" significance extended beyond these questions. At issue was Georgia’s constitutional right to resist federal judicial power "), _c('em', [_vm._v("in a dispute involving the Paris peace")]), _vm._v(", and thus to invite renewed conflict with Britain and fresh castigation of Americans in Europe. As went the sanctity of treaties, Jay feared, so went the republic’s reputation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 1792, the Court also heard arguments in "), _c('em', [_vm._v("Brailsford")]), _vm._v(" v. "), _c('em', [_vm._v("Georgia")]), _vm._v(", a suit in equity involving sequestered Loyalist property. The amount had become the object of an injunction, and, against the advice of his colleagues, Jay urged a continuance of the restraining order so that Georgia’s voluntary presence in "), _c('em', [_vm._v("Brailsford")]), _vm._v(" might be exploited in "), _c('em', [_vm._v("Chisholm.")]), _vm._v(" Both Randolph and Jay perceived connections between state suability and abrogations of the Paris peace through permanent sequestration and renunciation. The attorney general, for instance, re-ferred "), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }), _vm._v("suggestively in "), _c('em', [_vm._v("Chisholm")]), _vm._v(" to the fearsome implications of immunity for public safety. “The Federal head cannot remain unmoved,” he opined,")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("amidst these shocks to the public harmony. Are not peace and concord among the states two of the great ends of the Constitution? To be consistent, [my] opponents . . . must say, that a state may not be sued by a foreigner.—What? Shall the tranquility of our country be at the mercy of every State? . . . [Why] may not the measure be the same, when the citizen of another State is the complainant?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Did not the immunity doctrine lose “half of its force” when Georgia willingly and crassly appeared in "), _c('em', [_vm._v("Brailsford")]), _vm._v("—that is, when the state benefited from an appearance?"), _c('sup', [_c('a', {
    attrs: {
      "id": "iench275"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench275"
    }
  }, [_vm._v("75")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jay’s opinion leaves little doubt that, in his estimation, the Georgia cases went beyond garden-variety disagreements about federal and state power, ultimately reaching both of his “objects.” Before 1789, he recalled, the confederated states became “amenable to the law of nations,” and it was “their interest as well as their duty” to be so constrained. Amazingly, Americans still resisted the moral and political imperatives of nationhood—notably, their collective responsibility to harmonize and elevate the “conduct of each state, relative to the law of nations, and the performance of treaties.” Rather against hope, Jay wished that the “State of Society were so far improved, and the Science of Government [so perfected] that the whole nation could in the peaceable course of law, be compelled to do justice.” But, in 1793, such improvement seemed increasingly remote. Jay could only repeat that obedience, uniformity, and scrupulosity were fundamental to republican survival—that they were "), _c('em', [_vm._v("“wise")]), _vm._v(" . . . "), _c('em', [_vm._v("honest")]), _vm._v(" [and] "), _c('em', [_vm._v("useful.”")]), _c('sup', [_c('a', {
    attrs: {
      "id": "iench276"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench276"
    }
  }, [_vm._v("76")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The outcry after "), _c('em', [_vm._v("Chisholm")]), _vm._v(" and the related march toward constitutional limitation completely shattered Jay’s ever-diminishing faith in the high court’s political and diplomatic utility. In December 1792, the Georgia assembly had resolved not to be bound by an unfavorable court ruling; when the decision came down, a grand jury formally presented a grievance to Governor Telfair, who in turn urged passage of a statute (adopted two weeks later) affirming the state’s sovereign immunity. On March 18, Massachusetts lawmakers in special session commenced a drive to secure congressional adoption of what would become the Eleventh Amendment, making it impossible for federal marshals and judges to summon states as defendants. Virginia con-demned "), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }), _vm._v("Jay for attacking state sovereignty; Georgians toyed with hanging federal officers, should they again try to force a state appearance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("State concerns were not groundless. If allowed to stand, "), _c('em', [_vm._v("Chisholm")]), _vm._v(" probably rendered depleted state treasuries vulnerable to the claims of war suppliers and Loyalist “traitors”; it was plain, too, that Jay hoped to force several states to eat humble pie. On February 20, 1793, process had been returned and the state ordered to appear at the next term in "), _c('em', [_vm._v("Oswald")]), _vm._v(" v. "), _c('em', [_vm._v("New York.")]), _vm._v(" At virtually the same moment, the high court awarded a subpoena in "), _c('em', [_vm._v("Grayson et al.")]), _vm._v(" v. "), _c('em', [_vm._v("Virginia;")]), _vm._v(" five months later, when federal judges granted William Vassal (a Loyalist victim of the Massachusetts confiscation statute) a subpoena, Governor Hancock delivered a speech warning his countrymen of the perils of runaway judicial federalism.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hence, the flood of anti-Court sentiment leading to constitutional amendment. Jay had little trouble finding the door: with his Court effectively closed after 1793 to the resolution of European financial claims, he quickly transferred his efforts into personal diplomacy and eventually into support for a mixed international commission. In the year of his exit, the chief justice had been able in "), _c('em', [_vm._v("The Sloop Betsy")]), _vm._v(" to decry France’s use of its American consul as a prize agent, thereby shoring up the precarious United States claim of sovereignty, and his dissent on circuit in "), _c('em', [_vm._v("Ware")]), _vm._v(" v. "), _c('em', [_vm._v("Hylton")]), _vm._v(" (well before the 1796 Supreme Court ruling on the case) anticipated the Ellsworth Court’s affirmation of the republic’s obligation to abide by the terms of treaties. But such opportunities were few and, in the wake of "), _c('em', [_vm._v("Chisholm")]), _vm._v(", the political lesson was painfully clear: “objects of state” were not yet “far beyond the reach” of licentious men.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jay’s resignation thus symbolized keen disappointment, and, from the point of view of his colleagues marooned on a sinking federal bench, the situation could only get worse. On February 14, 1798, when the Eleventh Amendment took effect, the Supreme Court clerk, David Caldwell, spread over the minute book a pathetic list of cases (including, perhaps ironically, the nettlesome "), _c('em', [_vm._v("Brailsford)")]), _vm._v(" dismissed or discontinued for want of jurisdiction."), _c('sup', [_c('a', {
    attrs: {
      "id": "iench277"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench277"
    }
  }, [_vm._v("77")])]), _vm._v(" Had the bench been “on its proper footing,” Jay later explained, “there is no public Station that I should prefer.... It accords with my Turn of mind, my Education and my Habits.” Given Jay’s priorities, however, the high court was useless, especially when confronted with multiple or contrary visions of "), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }), _vm._v("what the polity ought to look like—an eventuality for which Jay, unlike the author of "), _c('em', [_vm._v("Federalist No. 10")]), _vm._v(", made inadequate provision."), _c('sup', [_c('a', {
    attrs: {
      "id": "iench278"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench278"
    }
  }, [_vm._v("78")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plainly, Jay’s “turn of mind” did not lie with the relatively tedious, incremental creation of a tradition in domestic law, with political process, or with the construction of judicial state papers; indeed, he may well have assumed that a Court operating under rules largely borrowed from King’s Bench should issue English-style, nonexpository opinions. Whatever the case might have been, Jay’s mind gravitated toward “systems” and far-reaching “objects,” not to the relatively staid, circumscribed world of legal research and writing. Arguably, he also had developed a taste for the spotlight, which federal courts rarely attracted. For these and other reasons, he finally branded the federal judiciary a “defective” department without sufficient “energy, weight and dignity” to provide that “due support” upon which the republic’s future seemed to depend."), _c('sup', [_c('a', {
    attrs: {
      "id": "iench279"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench279"
    }
  }, [_vm._v("79")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After 1794, Jay resolved anew “to see things as . . . they are, to estimate them aright, and to act accordingly”—a reassertion of “Fortitude founded on Resignation.” He then pressed his position on the debt question relentlessly through diplomacy. Apparently neither Jay nor Washington perceived conflict between service as a “private gentleman” on diplomatic assignment and as chief justice: the envoyship to Jay was simply a necessary, if personally inconvenient, exercise of duty and expertise. The president granted his envoy virtually a free hand with unpaid debts. Jay, he recalled, had been “personally conversant” with negotiators in Paris, served as foreign affairs secretary, and witnessed “what has passed in our [federal] courts” respecting confiscated property. Few men could claim so much."), _c('sup', [_c('a', {
    attrs: {
      "id": "iench280"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench280"
    }
  }, [_vm._v("80")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And fewer still were so determined. England, Jay warned, would surely “insist that British debts, so far as injured by lawful impediments, should be "), _c('em', [_vm._v("repaired")]), _vm._v(" by the United States, by decision of mutual commissioners.” He expected disapprobation, without which he would have been “agreeably disappointed”; he also hoped to ease his conscience. “Should the treaty prove . . . beneficial,” he announced, “justice will "), _c('em', [_vm._v("finally")]), _vm._v(" be done. If not, be it so—my mind is at ease.” In a revealing letter, Jay (who had been nominated in absentia by New York Federalists to run for governor) told Randolph that the debt-related Sixth Article addressed “that justice and equity which judicial proceedings may, on trial, be found incapable of affording,” for a neutral commission could do “exactly what is right.” Anxiety and anger "), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }), _vm._v("shared the stage with Jay’s conscience: as the contest over the Jay Treaty raged in Congress, and on the eve of his election to the New York governorship, he marveled at the insatiable appetites of scoundrels in legislative chambers, worrying aloud in a letter to his old friend Washington that rejection of the treaty would again “put the United States in the wrong,” damaging “honour, engagements, and important interests”—among them, the "), _c('em', [_vm._v("“further extension")]), _vm._v(" of commerce.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "iench281"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench281"
    }
  }, [_vm._v("81")])])]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('em', [_vm._v("The Judge as Arbiter of “The Common Good”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("How should scholars characterize Jay’s republican politics and statesmanship? First, the nation’s first chief justice was not reactionary, crassly self-interested, or politically liberal in any modern sense. John Jay despised pluralism. He was neither fluent in nor comfortable with the language of “rights.” With Joseph Story and other conservative legalists, he emphasized duties and obligations; but, more clearly in Jay than in others, the law of contract in its several manifestations (private, constitutional, and international) organized his legal and political consciousness, sometimes to the exclusion of all else. In 1793, to give one example, he told Chesapeake freeholders that, while republicans were “governed only by Laws ... of our own making,” those laws represented “Rules for regulating the Conduct of Individuals, and are established according to, "), _c('em', [_vm._v("&")]), _vm._v(" in pursuance of that Contract, which each Citizen has made with the Rest, and all with each. He is not a good Citizen,” said Jay emphatically, “who violates his Contract with Society; and when Society execute their laws, they do no more than what is necessary to constrain Individuals to perform that Contract, on the due operation and observance of which [t]he common Good "), _c('em', [_vm._v("&")]), _vm._v(" welfare of the Community depends.” Toward what ends did this contract—the embodiment of the old English right to law—aspire? Its “object,” said Jay, was to “secure to every man what belongs to him as a member of the nation, and by increasing the common Stock of Prosperity, to augment the Value of his Share in it. Most essentially therefore is it the Duty and Interest of us all, that the Laws be observed and irresistably executed.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "iench282"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench282"
    }
  }, [_vm._v("82")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For Jay, then, the rule of law was a “Fence” between civilization and barbarism, a mighty engine capable of instilling a divine spark in "), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }), _vm._v("ordinary men, a guarantor of liberty as entrepreneurs scrambled after wealth, and the scaffolding around which Americans would erect a national reputation and lasting prosperity. Jay did not devolve suddenly into political cynicism in the mid-1780s, as did a good many other Federalists. Instead, he was consistently “stiff in his self-righteousness,”"), _c('sup', [_c('a', {
    attrs: {
      "id": "iench283"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench283"
    }
  }, [_vm._v("83")])]), _vm._v(" disdainful of what Ralph Lerner has called “the New-Model Man,”"), _c('sup', [_c('a', {
    attrs: {
      "id": "iench284"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench284"
    }
  }, [_vm._v("84")])]), _vm._v(" and suspicious of republican enchantments with mediocrity, majoritarianism, and publicity. A consummate diplomatist, Jay neglected his own art with legislators and adversaries. He feared unruly commoners and nervously charted the course of Jacobinism in Europe, assiduously guarding the prerogatives of the “best Men” who alone could rescue America from its “present Condition.” And Jay no doubt lacked a fluid political imagination; amidst a revolution jerry-built from bits and pieces of British legalism, Lockean liberalism, Whig oppositionism, and post-Great Awakening Protestantism, he moved primarily from ancient history, political economy, the law of nations, and scripture—choices that betray a certain remoteness from the society at hand."), _c('sup', [_c('a', {
    attrs: {
      "id": "iench285"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench285"
    }
  }, [_vm._v("85")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jay’s grim view of human nature underlay all that he believed and became: for most of his life, he rejected the presumption of goodness (or at least human perfectibility) from which political liberalism proceeds. Lindley Murray said of the young Jay that he had been notable for “strong reasoning powers, comprehensive views, indefatigable application, and uncommon firmness of mind”; nowhere did Murray note Jay’s optimism, empathy, or great good humor. In midlife, and partly in response to the trauma of revolution, Jay’s intellectual proclivities crystallized into a sophisticated but rigidly legalistic variant of republicanism rooted firmly in existential despair and staunchly opposed to the twin doctrines of perfectibility and voluntarism. Few of the Founders preferred greater distance from the “Public,” devalued the general will so completely, and stressed the perils of lawlessness so constantly. In the end, Jay even distrusted himself, handing over prosperity, his ultimate object, to God and international law—the closest approximation of godly wisdom available to humankind—for safekeeping. “[W]ho made the Laws of Nations?” he asked rhetorically in the year of the Georgia cases. “The answer is "), _c('em', [_vm._v("he")]), _vm._v(" from whose "), _c('em', [_vm._v("will")]), _vm._v(" proceed all moral Obligations, and which "), _c('em', [_vm._v("will")]), _vm._v(" is made known to us by Reason or Revelation.” At home, unification behind a supreme manmade law might suffice, but, in dealings with Europeans, where "), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }), _vm._v("traders and politians might succumb to temptation or where public displays of dirty laundry might lead to war, there would be “no Judge but the great Judge of all.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "iench286"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench286"
    }
  }, [_vm._v("86")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In eighteenth-century understandings, these were eminently conservative ideas, but they were not precisely reactionary. While Jay preferred Court to country politics, his “system” fell easily within the broad spectrum of Revolutionary discourse. Unlike Old Guard curmudgeons, Jay found republican forms plausible, if regrettably optimistic and poorly implemented. And, unlike Hamilton, Jay fulsomely embraced important elements of economic liberalism, championing free trade and agrarianism as avenues to national standing and wealth. By 1776, he had embraced the necessity of independence—grudgingly, to be sure, and no doubt as much to conserve wealth as to advance republican liberty, but nonetheless irrevocably. Thereafter, by articulating contrary “objects,” tactics, and institutional arrangements among peers far more responsive in 1787 than earlier, Jay became a constructive participant in revolutionary change and the embodiment of the marriage—apparent in a good many Founders—between free-trading liberalism and political corporatism, the whole made safe for wayward republicans with lavish doses of law.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jay’s emphasis upon global commerce and “independence for friendship” as a main object of domestic unification differed appreciably from Marshall’s priorities; to a great extent, the federal judiciary rose to power after 1800 by turning inward, away from Europe and the law of nations toward the American hinterland and bodies of domestic law. Jay proposed a “comprehensive”"), _c('sup', [_c('a', {
    attrs: {
      "id": "iench287"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench287"
    }
  }, [_vm._v("87")])]), _vm._v(" rather than introspective system of politics and law—an organic whole conspiring slowly and fitfully under law toward a collective, ultimately global state of grace. Jay hoped, too, that this homogenizing process would be supervised by wise, wellborn statesmen. To both domestic and international spheres, he assigned separate allegiances and “objects.” But these memberships and goals were unequally weighted and intricately joined: at every turn, domestic political economy supported its more important international counterpart. The sheer delicacy of this balancing act generated considerable apprehension in Jay: “It cannot be too strongly impressed on the Minds of us all,” he tautly instructed several grand juries in 1790, “how greatly our individual Prosperity depends on our national Prosperity; and how greatly our national "), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }), _vm._v("Prosperity depends on a well organized vigorous Government, ruling by wise and equal Laws, faithfully executed.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "iench288"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench288"
    }
  }, [_vm._v("88")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The particular urgencies underlying these remarks had diminished appreciably by 1801, but, in 1789, no agenda seemed to touch the public good more directly. Jay’s plan therefore represented more than the selfish agitations of an Empire State capitalist. To ignore economic and strategic weaknesses, Jay thought, was to invite Jacob’s bad use of Esau’s weakened condition,"), _c('sup', [_c('a', {
    attrs: {
      "id": "iench289"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench289"
    }
  }, [_vm._v("89")])]), _vm._v(" for brave assertions about a republic’s inevitable prosperity strained hard against history and against a very thorny reality. To Jay’s mind, an omnipresent law ensured moral judgment and moral action among republicans predisposed as a group to selfishness, licentiousness, and evil: when Alexander Hamilton advocated manipulation of election returns in 1800 to defeat Thomas Jefferson, Jay quietly wrote off both Hamilton and Federalism. Better to sacrifice party and individuals than to leave high moral ground."), _c('sup', [_c('a', {
    attrs: {
      "id": "iench290"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench290"
    }
  }, [_vm._v("90")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To modern eyes, Jay’s values can seem outmoded and reprehensible. These reactions, however, often reflect impatience with failed imagination—to make matters worse, on the losing side of history. Scholars know how the story came out, and so tend to demonstrate “the inevitability of the evolution they describe.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "iench291"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench291"
    }
  }, [_vm._v("91")])]), _vm._v(" Federalists like Jay and Marshall indeed shared a uniform vocabulary of legalism and nationalism. But the meanings, shadings, and priorities conveyed through language necessarily varied according to the speaker and his context. Jay clearly infused such terms as “nation” or “federal law” with meanings that reflected his own intellect, experience, and reading of republican circumstance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As Morris once noted, a campaign to secure controversial review powers in the 1790s would have been foolhardy; on circuit, moreover, Jay’s colleagues quietly and steadily hammered away at the possibility, carrying the idea of judicial purview over congressional acts as far as political opponents allowed it to be carried."), _c('sup', [_c('a', {
    attrs: {
      "id": "iench292"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench292"
    }
  }, [_vm._v("92")])]), _vm._v(" For the Court itself, Jay mostly had in mind other objectives. More pressing by far was national establishment within reliable, respected structures—labors for which Jay’s “turn of mind,” broad interests, and nonspecialized statecraft were especially well adapted. In the absence of a guiding “Light of Experience,” Jay’s colleagues hammered out rules and procedures appropriate to an unrealized appellate practice—a thankless task if ever there was one. Simultaneously, the chief justice tried to solidify an alliance with the executive branch, fearing with Hamilton that a "), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }), _vm._v("bench with “neither Force nor Will, but merely judgment” would soon collapse."), _c('sup', [_c('a', {
    attrs: {
      "id": "iench293"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench293"
    }
  }, [_vm._v("93")])]), _vm._v(" He also explored the Court’s potential as an agency of “honour, justice, and interest” against incipient evil. Laboring to sensitize republicans to the perils of their chosen form of government, he concluded by 1794 that citizens still refused a very difficult but critical discipline, and that he could not secure a permanent state of grace for his countrymen through federal courts. Privately, he awaited the millennium; as a statesman, he pursued “great and obvious principles” elsewhere.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Arguably, these ideas constitute an alternative conception of ideal relations between polity, economy, and law rather than a prelude to modernism. Scholars may rightly decide that Jay lacked genius and political generosity, that he was a poor excuse for an appellate judge, and that his “system” was too fragile and too tightly bound to context to wear well. But similar complaints have not prevented engagement with the likes of Roger Taney or Chancellor James Kent, whose ambiguities and illiberalism have been absorbed, if not entirely forgiven. And, in the decade after ratification, Jay’s professional style—so much a part of an oracular tradition in judgeship"), _c('sup', [_c('a', {
    attrs: {
      "id": "iench294"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench294"
    }
  }, [_vm._v("94")])]), _vm._v("—was common enough.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("More important, and scholarly approval aside, meaningful comparisons with later practice depend upon an initial grant of seriousness. The desire to provide consistent standards through law against which republicans might measure moral progress, for example, or the idea that political work transcends constituencies and institutions, both give pause. At the least, John Jay’s vision increases the distance between 1789 and 1801, clarifying and complicating our understanding of how the third branch came to occupy modern ground. Even Jay’s champion, Richard Morris, saw clearly that Jay was a product (as are we all) of his historical moment; he only failed to see that, in a cultural and perhaps social-psychological sense, Marshall’s moment was light years removed from the terrors and thrills of 1789. Said Morris in 1967, John Jay’s “tireless effort to endow the national government with energy, capacity, and scope . . . attest to his vision, courage, and tenacity. It remained for others to spell out the safeguards for individual liberties and the limitation on national power . . . essential to the maintenance of a democratic society.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "iench295"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#ench295"
    }
  }, [_vm._v("95")])])]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("NOTES"), _c('a', {
    attrs: {
      "id": "page_57"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench21"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench21"
    }
  }, [_vm._v("1")]), _vm._v(". Quoted in Gordon Wood, "), _c('em', [_vm._v("The Creation of the American Republic")]), _vm._v(" (Chapel Hill 1969), 420.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench22"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench22"
    }
  }, [_vm._v("2")]), _vm._v(". David Hackett Fischer, "), _c('em', [_vm._v("The Revolution of American Conservatism")]), _vm._v(" (New York 1965), 7-10, esp. 8. See also George Pellew, "), _c('em', [_vm._v("John Jay")]), _vm._v(" (Boston 1890); Merrill Jensen, "), _c('em', [_vm._v("The New Nation")]), _vm._v(" (New York 1950), 13-14, 365-366, and passim; Frank Monaghan, "), _c('em', [_vm._v("John Jay, Defender of Liberty")]), _vm._v(" (New York and Indianapolis 1935); Gottfried Dietze, "), _c('em', [_vm._v("The Federalist")]), _vm._v(" (Baltimore 1960), 105-111; Jack Rakove, "), _c('em', [_vm._v("The Beginnings of National Politics")]), _vm._v(" (Baltimore 1979), 53-56; the biographical sketch in Donald L. Smith, "), _c('em', [_vm._v("John Jay: Founder of a State and Nation")]), _vm._v(" (New York 1968); Herbert Johnson, "), _c('em', [_vm._v("John Jay, 1745-1829")]), _vm._v(" (Albany, N.Y. 1970), and “John Jay: Lawyer in a Time of Transition, 1764-1775,” "), _c('em', [_vm._v("University of Pennsylvania Law Review")]), _vm._v(", 124 (May 1976), 1260-1292. See also the biographical detail in commentaries of William Jay in "), _c('em', [_vm._v("The Life of John Jay: Selections from His Correspondence and Miscellaneous Papers")]), _vm._v(" (2 vols., New York 1833), esp. Vol. 1,1-68, a collection that William overzealously edited to protect his father’s reputation, and in Richard B. Morris’s introduction to "), _c('em', [_vm._v("John Jay, The Making of a Revolutionary: Unpublished Papers, 1745-1780")]), _vm._v(" (2 vols., New York 1975), Vol. I, 1-26, cited hereafter as Morris, "), _c('em', [_vm._v("Unpublished Papers.")]), _vm._v(" Among Morris’s interpretive works "), _c('em', [_vm._v("Sire John Jay, the Nation, and the Court")]), _vm._v(" (Boston 1967); "), _c('em', [_vm._v("The Peacemakers")]), _vm._v(" (New York 1965); "), _c('em', [_vm._v("Seven Who Shaped Our Destiny")]), _vm._v(" (New York 1973), ch. 5; “The John Jay Court: An Intimate Profile,” "), _c('em', [_vm._v("Journal of Contemporary Law, 5")]), _vm._v(" (Spring 1979), 163-179; “The American Revolution Comes to John Jay,” in Jacob Judd and Irwin Polishook, eds., "), _c('em', [_vm._v("Aspects of Early New York Society and Politics")]), _vm._v(" (Tar-rytown, N.Y. 1974), 96-117; and the more recent (and slightly less positive) account, “John Jay: Aristocrat as Nationalist,” in Morris, "), _c('em', [_vm._v("Witnesses at the Creation: Hamilton, Madison, Jay, and the Constitution")]), _vm._v(" (New York 1985). Milton Klein accurately summarized scholarly attitudes in his review of Morris’s edition of Jay’s papers, "), _c('em', [_vm._v("American Journal of Legal History")]), _vm._v(", 21 (Oct. 1977), 365-369. See also Morris’s "), _c('em', [_vm._v("Forging of the Union, 1781-1789")]), _vm._v(" (New York 1987), in which he weaves John Jay as a diplomatist and statesman into the fabric of the framing decade far more persuasively than in earlier, somewhat strained accounts. See also Sandra VanBurkleo, “John Jay,” in Melvin Urofsky, ed., "), _c('em', [_vm._v("Supreme Court Justices: A Biographical Dictionary")]), _vm._v(" (Westport, Conn. 1995), 263-269.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench23"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench23"
    }
  }, [_vm._v("3")]), _vm._v(". On the power to review acts of Congress, see "), _c('em', [_vm._v("Mar bury")]), _vm._v(" v. "), _c('em', [_vm._v("Madison")]), _vm._v(", 1 Cranch 137 (1803). See also Robert Lowry Clinton, "), _c('em', [_vm._v("Mar bury v. Madison and Judicial Review")]), _vm._v(" (Lawrence, Kans. 1989), and Sylvia Snowiss, "), _c('em', [_vm._v("Judicial Review and the Law of the Constitution")]), _vm._v(" (New Haven 1990).")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench24"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench24"
    }
  }, [_vm._v("4")]), _vm._v(". For negative, positive, and compromise positions, see Samuel Bemis, "), _c('em', [_vm._v("Jay’s Treaty: A Study in Commerce and Diplomacy")]), _vm._v(" (New York 1923); Morris, "), _c('em', [_vm._v("Peacemakers;")]), _vm._v(" and Jerald Combs, "), _c('em', [_vm._v("The Jay Treaty")]), _vm._v(" (Berkeley 1970). Alexander De-Conde’s "), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }), _c('em', [_vm._v("Entangling Alliances")]), _vm._v(" (Durham, N.C. 1958) supplies additional detail about Jay’s diplomatic career.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench25"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench25"
    }
  }, [_vm._v("5")]), _vm._v(". Jay to Judge Lowell, Feb. 29, 1796, in Henry P. Johnston, ed., "), _c('em', [_vm._v("The Correspondence and Public Papers of John Jay")]), _vm._v(" (4 vols., New York 1891), IV, 204-205. Hereafter cited as Johnston, "), _c('em', [_vm._v("Jay Papers.")]), _vm._v(" The expectation of modern attitudes toward separation of powers and professional specialization leads Morris to argue that Jay’s failure to resign was a well-intended “lapse” that provided a dangerous precedent for “overstepping” separation of powers; "), _c('em', [_vm._v("John Jay")]), _vm._v(", 92-93. Morris’s edition of unpublished papers, unlike Johnston’s old edition, preserves the original spelling, punctuation, and capitalization, but it does not include all of Jay’s writings. Few attempts have been made here to reconcile differing editorial practices. Where possible, I rely on the transcriptions in Maeva Marcus et al., eds., "), _c('em', [_vm._v("Documentary History of the United States Supreme Court, 1789-1800")]), _vm._v(" (5 vols. to date, New York 1985-). Cited hereafter as Marcus, "), _c('em', [_vm._v("Documentary History.")])]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench26"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench26"
    }
  }, [_vm._v("6")]), _vm._v(". Robert McCloskey, "), _c('em', [_vm._v("The American Supreme Court")]), _vm._v(" (Chicago 1960), 30; Charles Grove Haines, "), _c('em', [_vm._v("The Role of the Supreme Court in American Government and Politics, 1789-1835")]), _vm._v(" (New York 1960), 124; Alfred Kelly, Winfred Harbison, and Herman Belz, "), _c('em', [_vm._v("The American Constitution")]), _vm._v(" (6th ed., New York 1983), 164-167; and Morris, "), _c('em', [_vm._v("John Jay")]), _vm._v(", 69. See also Morris, “Intimate Profile,” wherein Jay is portrayed as a typical “nationalist chief justice” who sought review powers without adequate support. He also links Jay’s views on judicial autonomy to Marshall’s, primarily because of Jay’s resistance to formal advice in "), _c('em', [_vm._v("Hay burn’s Case")]), _vm._v(" and "), _c('em', [_vm._v("Sloop Betsy, 2")]), _vm._v(" Dallas 409 (1792), Jay and Associate Justices to Washington, July 20, 1793, in Johnston, "), _c('em', [_vm._v("Jay Papers")]), _vm._v(", III, 486-489. On formal parallels between Jay and Marshall in the use of syllogism or nationalist language, see Morris, "), _c('em', [_vm._v("John Jay")]), _vm._v(", 56-60, 70,102, or G. Edward White, "), _c('em', [_vm._v("The American Judicial Tradition")]), _vm._v(" (New York 1976), 25, 27-30.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench27"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench27"
    }
  }, [_vm._v("7")]), _vm._v(". George Washington to Jay, Oct. 5, 1789, in Johnston, "), _c('em', [_vm._v("Jay Papers")]), _vm._v(", III, at 378.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench28"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench28"
    }
  }, [_vm._v("8")]), _vm._v(". Charge to the Grand Jury of the Circuit Court for the District of New York, April 12, 1790, in Marcus, "), _c('em', [_vm._v("Documentary History")]), _vm._v(", II, 27. On the Eleventh Amendment, see William Guthrie, “The Eleventh Article of Amendment to the Constitution of the United States,” "), _c('em', [_vm._v("Columbia Law Review")]), _vm._v(", 8 (Mar. 1908), 183-207, which should be read alongside Clyde Jacobs’s more sensitive "), _c('em', [_vm._v("The Eleventh Amendment and Sovereign Immunity")]), _vm._v(" (Westport, Conn. 1972), and compared with Julius Goebel, "), _c('em', [_vm._v("History of the Supreme Court of the United States: Antecedents and Beginnings to 1801")]), _vm._v(" (New York 1971), esp. 736-741, which is hostile to Jay. See also Jacobs, “Prelude to Amendment: The States Before the Court,” "), _c('em', [_vm._v("American Journal of Legal History")]), _vm._v(", 12 (Jan. 1968), 19-40, and Louis Jaffe, “Suits Against Governments and Officers: Sovereign Immunity,” "), _c('em', [_vm._v("Harvard Law Review")]), _vm._v(", 77 (Nov. 1963), 1-39.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench29"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench29"
    }
  }, [_vm._v("9")]), _vm._v(". Goebel, "), _c('em', [_vm._v("History of the Supreme Court, 552")]), _vm._v(" and 729-733, also credits Jay "), _c('a', {
    attrs: {
      "id": "page_59"
    }
  }), _vm._v("with initiating the “lamentable standards of American judicial historiography.” On Jay’s "), _c('em', [_vm._v("Federalist")]), _vm._v(" contributions and the acknowledgment among contemporaries of diplomatic expertise, see Douglass Adair, “The Authorship of the Disputed Federalist Papers,” "), _c('em', [_vm._v("William and Mary Quarterly")]), _vm._v(", 1 (Jan. 1944), 97-122, (Apr. 1944), 235-264, esp. 246. For Washington’s acknowledgment, see Instructions as Envoy Extraordinary, 1794, in Johnston, ed., "), _c('em', [_vm._v("Jay Papers")]), _vm._v(", IV, 14.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench210"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench210"
    }
  }, [_vm._v("10")]), _vm._v(". Morris, "), _c('em', [_vm._v("John Jay")]), _vm._v(", 100.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench211"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench211"
    }
  }, [_vm._v("11")]), _vm._v(". I attribute Jay’s unremitting anxiety about the character of “the people out of doors” as much to Calvinism as to class; others disagree, though no one (me included) has pursued this question rigorously.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench212"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench212"
    }
  }, [_vm._v("12")]), _vm._v(". Gordon Wood, "), _c('em', [_vm._v("The Radicalism of the American Revolution")]), _vm._v(" (New York 1992), 271. Interestingly, Wood seems to attribute the old gentry’s decline—at least in the North—to capitalist expansion and (possibly) to the triumph of middling over monied classes: “With the weakening and disappearance of older forms of patronage, with the expansion of commerce and the fluctuating redistributions of wealth, with the spread of paper money and the widening commercial opportunities for plain and ‘middling’ men everywhere, the gentry’s position in northern society became more and more anachronistic.” Ibid.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench213"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench213"
    }
  }, [_vm._v("13")]), _vm._v(". Bernard Bailyn, "), _c('em', [_vm._v("Education in the Forming of American Society")]), _vm._v(" (New York 1960), 14. Legal scholars too often consider that the Revolution ended with ratification, which helps explain unhistorical readings of judicial motivations before 1801. For the periodization of Revolutionary process adopted here, see John Howe, “Republican Thought and the Political Violence of the 1790’s,” "), _c('em', [_vm._v("American Quarterly")]), _vm._v(", 19 (Summer 1967), 147-165.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench214"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench214"
    }
  }, [_vm._v("14")]), _vm._v(". Jay to John Adams, Jan. 2, 1801, in Johnston, ed., "), _c('em', [_vm._v("Jay Papers")]), _vm._v(", IV, 285.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench215"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench215"
    }
  }, [_vm._v("15")]), _vm._v(". On relationships between Smith’s economic and moral philosophy, see Donald Winch, "), _c('em', [_vm._v("Adam Smith’s Politics")]), _vm._v(" (Cambridge, Eng. 1978), or Robert Nis-bet, "), _c('em', [_vm._v("History of the Idea of Progress")]), _vm._v(" (New York 1980), esp. 187-193, arguing that Smith’s precept of “natural liberty” in the marketplace arises as easily from “prepolitical social bonds” as from an “invisible hand” divorced from the polity.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench216"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench216"
    }
  }, [_vm._v("16")]), _vm._v(". Federalist Nos. 2 and 4, in Jacob E. Cooke, ed., "), _c('em', [_vm._v("The Federalist")]), _vm._v(" (Middle-town, Conn. 1961), 9, 22. Hereafter cited as Cooke, "), _c('em', [_vm._v("Federalist.")])]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench217"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench217"
    }
  }, [_vm._v("17")]), _vm._v(". Jay to Washington, Apr. 21, 1779, in Morris, "), _c('em', [_vm._v("Unpublished Papers")]), _vm._v(", I, 586-587.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench218"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench218"
    }
  }, [_vm._v("18")]), _vm._v(". Jay to Gouverneur Morris, Apr. 29, 1778, ibid., 476; Jay to Richard Price, Sept. 27, 1785, Jay to Washington, June 27, 1786, in Johnston, "), _c('em', [_vm._v("Jay Papers")]), _vm._v(", III, 168-169, 205. Also see Jay to R. Lushington, Mar. 15, 1786, ibid., 185-186; or Jay to Robert Livingston and Morris, Apr. 29, 1777, and to Egbert Benson, Sept. 18, 1780, in Morris, "), _c('em', [_vm._v("Unpublished Papers")]), _vm._v(", 1,401, 823. Jay’s religiosity is never disputed; e.g., Morris, "), _c('em', [_vm._v("John Jay")]), _vm._v(", 12, 86.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench219"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench219"
    }
  }, [_vm._v("19")]), _vm._v(". Jay to Morris, July 21, 1777, Jay to Alexander McDougall, Dec. 23, "), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }), _vm._v("1775, in Morris, "), _c('em', [_vm._v("Unpublished Papers")]), _vm._v(", I, 423, 213. In addition, see Jay to Wash-ington, Apr. 22, 1779, and to Sarah Jay, June 22, 1775, ibid., 586, 154.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench220"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench220"
    }
  }, [_vm._v("20")]), _vm._v(". Jay to Washington, Sept. 21, 1788, in Johnston, "), _c('em', [_vm._v("Jay Papers")]), _vm._v(", III, 360; Jay to Lindley Murray, Aug. 22, 1794, to William Vaughan, May 26, 1796, to Benjamin Rush, Mar. 22, 1797, and to Judge Peters, Mar. 14, 1815, ibid., IV, 52, 215-216, 226, 387. With other Federalists, Jay advocated popular sovereignty while distinguishing between legal and social equality, and so could say that, while republicans were intractibly unequal in social terms, the “only source of just authority” was "), _c('em', [_vm._v("“the People”;")]), _vm._v(" Jay to Washington, Jan. 7, 1787, ibid., Ill, 229. For “Evils inseparable from Humanity,” see Jay to Sarah Jay, Mar. 25, 1777, in Morris, "), _c('em', [_vm._v("Unpublished Papers, I")]), _vm._v(", 382.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench221"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench221"
    }
  }, [_vm._v("21")]), _vm._v(". Federalist No. 2, in Cooke, "), _c('em', [_vm._v("Federalist")]), _vm._v(", 8; Edward Rutledge to Jay, June 29, 1776, and Jay’s reply, July 6, 1776, in Morris, "), _c('em', [_vm._v("Unpublished Papers, I")]), _vm._v(", 281, 28In, wherein he says Rutledge’s ideas “parallel” his own; Jay to Judge Peters, Mar. 14, 1815, in Johnston, "), _c('em', [_vm._v("Jay Papers")]), _vm._v(", IV, 387. On Jacobinism, see, e.g., Jay to Washington, March 6, 1795, ibid., 162-171.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench222"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench222"
    }
  }, [_vm._v("22")]), _vm._v(". Jay to William Vaughan, May 26, 1796, and to Washington, Feb. 25, 1795, Johnston, "), _c('em', [_vm._v("Jay Papers")]), _vm._v(", IV, 216, 161.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench223"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench223"
    }
  }, [_vm._v("23")]), _vm._v(". Jay to Washington, Apr. 21, 1779, and Rutledge to Jay, June 29, 1776, in Morris, "), _c('em', [_vm._v("Unpublished Papers")]), _vm._v(", I, 586, 281; and Jay to Francis Hopkinson, Mar. 29, 1786, in Johnston, "), _c('em', [_vm._v("Papers")]), _vm._v(", III, 187-188. In the same vein, see Rutledge to Jay, Dec. 25, 1778, Jay to Morris, Apr. 29, 1778, in Morris, "), _c('em', [_vm._v("Unpublished Papers")]), _vm._v(", I, 516, 475; and Jay to Washington, Jan. 7, 1787, in Johnston, "), _c('em', [_vm._v("Jay Papers")]), _vm._v(", III, 227.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench224"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench224"
    }
  }, [_vm._v("24")]), _vm._v(". Jay to Judge Lowell, Feb. 29, 1796, to Peter Van Schaack, July 28, 1812, and to Washington, Feb. 25, 1795, in Johnston, "), _c('em', [_vm._v("Jay Papers")]), _vm._v(", IV, 204, 361, 161.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench225"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench225"
    }
  }, [_vm._v("25")]), _vm._v(". Federalist Nos. 2 and 3, in Cooke, "), _c('em', [_vm._v("Federalist")]), _vm._v(", 11-12, 15, 17; Jay to Washington, Sept. 21, 1788, in Johnston, "), _c('em', [_vm._v("Jay Papers")]), _vm._v(", III, 361; Rutledge to Jay, June 29, 1776, Jay to Philip Schuyler, Dec. 11, 1777, and New York Convention to John Hancock [July 10], 1776, in Morris, "), _c('em', [_vm._v("Unpublished Papers")]), _vm._v(", I, 281, 453, 291.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench226"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench226"
    }
  }, [_vm._v("26")]), _vm._v(". Jay to Sarah Jay, Mar. 25, 1777, in Morris, "), _c('em', [_vm._v("Unpublished Papers")]), _vm._v(", I, 382, and Federalist No. 2, in Cooke, "), _c('em', [_vm._v("Federalist")]), _vm._v(", 12. On “resignation” and “duty,” see also Jay to Robert Livingston, Jan. 6, 1776, in Morris, "), _c('em', [_vm._v("Unpublished Papers, I")]), _vm._v(", 223; Jay to Sarah Jay, Apr. 15, 1794, and to Lindley Murray, Aug. 22, 1794, in Johnston, "), _c('em', [_vm._v("Jay Papers")]), _vm._v(", IV, 3, 51.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench227"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench227"
    }
  }, [_vm._v("27")]), _vm._v(". Proofs that the Colonies Do Not Aim at Independence [after Dec. 11, 1775], and Jay to Alexander McDougall, Oct. 17, 1775, in Morris, "), _c('em', [_vm._v("Unpublished Papers")]), _vm._v(", I, 199, 172. On “lasting Union,” see Jay to John Vardill, Sept. 24, 1774, and Draft of the Olive Branch Petition, June 1775, ibid., 137, 152-154, urging unification to secure “Harmony . . . Wealth and Power.”")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench228"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench228"
    }
  }, [_vm._v("28")]), _vm._v(". See, e.g., Federalist No. 5, in Cooke, "), _c('em', [_vm._v("Federalist")]), _vm._v(", 23-24.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench229"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench229"
    }
  }, [_vm._v("29")]), _vm._v(". Jay to Morris, Apr. 29, 1778, in Morris, "), _c('em', [_vm._v("Unpublished Papers")]), _vm._v(", I, 475-476. "), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }), _vm._v("Morris characterizes Jay more positively as a “prudent revolutionary”; "), _c('em', [_vm._v("John Jay")]), _vm._v(", 3.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench230"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench230"
    }
  }, [_vm._v("30")]), _vm._v(". See Wood, "), _c('em', [_vm._v("Creation")]), _vm._v(", 419-421, where New Yorkers’ criticisms are virtually equated with self-interest.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench231"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench231"
    }
  }, [_vm._v("31")]), _vm._v(". For national “objects,” see Federalist Nos. 2 and 3, in Cooke, "), _c('em', [_vm._v("Federalist")]), _vm._v(", 12-15. Jay also associated unity with safety.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench232"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench232"
    }
  }, [_vm._v("32")]), _vm._v(". Jay to Judge Lowell, May 10, 1785, and to Washington, June 27, 1786, in Johnston, "), _c('em', [_vm._v("Jay Papers")]), _vm._v(", III, 143, 205. For the Lowell letter capitalizations, see William Jay’s commentary in "), _c('em', [_vm._v("Letters of John Jay")]), _vm._v(", I, 190, and Frank Monaghan’s discussion of Johnston’s version, "), _c('em', [_vm._v("John Jay")]), _vm._v(", 282, 454 at note 6.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench233"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench233"
    }
  }, [_vm._v("33")]), _vm._v(". Jay to Alexander McDougall, Apr. 11, 1776, to James Duane, Dec. 14, 1777, and to Washington, Apr. 21, 1779, in Morris, "), _c('em', [_vm._v("Unpublished Papers")]), _vm._v(", I, 254, 454, 586. In the last, Jay scratched out a phrase suggesting that the people lacked “wisdom.” The best source for details about Jay’s difficulties with Congress after 1783 remains Johnston, "), _c('em', [_vm._v("Jay Papers")]), _vm._v(", III, 104-378; on difficulties before then, see Morris, "), _c('em', [_vm._v("Peacemakers")]), _vm._v(", passim. Misgivings about collective decision making in maritime or economic affairs emerged early. See, e.g., Jay to Washington, Apr. 26, 1779, in Morris, "), _c('em', [_vm._v("Unpublished Papers")]), _vm._v(", I, 587-588.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench234"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench234"
    }
  }, [_vm._v("34")]), _vm._v(". Jay to Governor Livingston, July 19, 1783, to Thomas Jefferson, Oct. 27, 1786, to Adams, Feb. 21, 1787, and to Jefferson, Nov. 3, 1787, in Johnston, "), _c('em', [_vm._v("Jay Papers")]), _vm._v(", III, "), _c('em', [_vm._v("55")]), _vm._v(", 212, 235, 260. On congressional absenteeism, see Jay to Jefferson, Jan. 9, 1786, and to Jacob Read, Dec. 12, 1786, ibid., 178, 222.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench235"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench235"
    }
  }, [_vm._v("35")]), _vm._v(". Report to Congress on a Joint Letter from Adams and Jefferson, May 29, 1786, and Address to the People of the State of New York, Spring 1788, ibid., 198-199, 298-301.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench236"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench236"
    }
  }, [_vm._v("36")]), _vm._v(". Jay to Washington, June 27, 1786, and to Jefferson, Apr. 24, 1787, ibid., 204, 244. On rebellion and feeble government, see Jay to Adams, Nov. 1, 1786, to William Carmichael, Jan. 4, 1787, and to Jefferson, Feb. 9, 1787, ibid., 214, 225, 232.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench237"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench237"
    }
  }, [_vm._v("37")]), _vm._v(". Jay to Governor Livingston, July 19, 1783, to Adams, Feb. 21, 1787, to Washington, Jan. 7, 1787, and to William Vaughan, May 26, 1796, ibid., Ill, 55, 234, 227; IV, 216. Also see Jay to Jefferson, Aug. 18, 1786, ibid., Ill, 210-211.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench238"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench238"
    }
  }, [_vm._v("38")]), _vm._v(". Rutledge to Jay, June 29, Nov. 24, 1776, in Morris, "), _c('em', [_vm._v("Unpublished Papers")]), _vm._v(", I, 281, 322; Jay to Washington, Jan. 7, 1787, in Johnston, "), _c('em', [_vm._v("Jay Papers")]), _vm._v(", III, 227.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench239"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench239"
    }
  }, [_vm._v("39")]), _vm._v(". Here, Jay echoed other High Federalists. See, e.g., Jay to Jefferson, Aug. 18, 1786, in Johnston, "), _c('em', [_vm._v("Jay Papers")]), _vm._v(", III, 210-211, and Gordon Wood’s discussion of competing conceptions of “worthiness,” constitutional decay, and separation of powers, in "), _c('em', [_vm._v("Creation")]), _vm._v(", 471-518. But see also Jay’s extreme recommendations to Washington, Jan. 7, 1787, in Johnston, "), _c('em', [_vm._v("Jay Papers")]), _vm._v(", III, 227, concerning life tenure for senators and annual election for House members, presumably to conserve wisdom and rout out demagoguery. On collaboration, advisory councils, and the "), _c('a', {
    attrs: {
      "id": "page_62"
    }
  }), _vm._v("royal prerogative, see Federalist No. 4, in Cooke, "), _c('em', [_vm._v("Federalist")]), _vm._v(", 20; Address to the People of the State of New York, Spring 1788, and Jay to the Chevalier de Bour-going, Aug. 29, 1788, and to Washington, Jan. 7, 1787, in Johnston, "), _c('em', [_vm._v("Jay Papers")]), _vm._v(", III, 316, 355-356, 227.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench240"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench240"
    }
  }, [_vm._v("40")]), _vm._v(". Charge to the Grand Jury of the Circuit Court for the District of New York, April 12, 1790, and Charge to the Grand Jury of the Circuit Court for the District of Virginia [Richmond], May 22, 1793, in Marcus, "), _c('em', [_vm._v("Documentary History")]), _vm._v(", II, 28, 30, 390. On crown-court relations, see J. H. Baker, "), _c('em', [_vm._v("Introduction to English Legal History")]), _vm._v(" (London 1971), 39-50, or S. F. C. Milsom, "), _c('em', [_vm._v("Historical Foundations of the Common Law")]), _vm._v(" (London 1969), 74-87. Charles Warren tied Jay’s notion of cooperation to partisan politics, "), _c('em', [_vm._v("The Supreme Court in United States History (2")]), _vm._v(" vols., Boston 1926), I, 85-112. On mixed and departmental government, see Wood, "), _c('em', [_vm._v("Creation")]), _vm._v(", 197-256. Part of Jay’s preference for British forms sprang from hatred of the “former arbitrary government” of France, which was “dreadful”; his vision of vigorous executive and judicial power included strict adherence among statesmen to the rule of law. See Jay to Robert Goodloe Harper, Jan. 19, 1796, in Johnston, "), _c('em', [_vm._v("Jay Papers")]), _vm._v(", IV, 200-201. See also Federalist No. 3, in Cooke, "), _c('em', [_vm._v("Federalist")]), _vm._v(", 15.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench241"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench241"
    }
  }, [_vm._v("41")]), _vm._v(". Wood, "), _c('em', [_vm._v("Creation")]), _vm._v(", 159, 472-473; Martin Diamond, “What the Framers Meant by Federalism,” in Robert Goldwin, ed., "), _c('em', [_vm._v("A Nation Of States")]), _vm._v(" (Chicago 1974), 31-33; and Jay’s allusion to Washington, Mar. 16, 1786, Johnston, "), _c('em', [_vm._v("Jay Papers")]), _vm._v(", 111, 186-187.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench242"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench242"
    }
  }, [_vm._v("42")]), _vm._v(". Jay to Washington, Jan. 7, 1787, to Adams, Oct. 14, 1785, to Jefferson, Dec. 14, 1786, to James Lowell, May 10, 1785, and to Adams, May 4, 1786, in Johnston, "), _c('em', [_vm._v("Jay Papers")]), _vm._v(", III, 228, 172, 224, 143, 195; Federalist No. 3, in Cooke, "), _c('em', [_vm._v("Federalist")]), _vm._v(", 15; and Jay to Washington, Apr. 21, 1779, in Morris, "), _c('em', [_vm._v("Unpublished Papers, 586.")])]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench243"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench243"
    }
  }, [_vm._v("43")]), _vm._v(". Federalist Nos. 2 and 4, in Cooke, "), _c('em', [_vm._v("Federalist")]), _vm._v(", 13, 22-23; Charge to the Grand Jury of the Circuit Court for the District of New York, April 12, 1790, in Marcus, "), _c('em', [_vm._v("Documentary History")]), _vm._v(", II, as at 29. See also Jay’s Address to the People of the State of New York, Spring 1788, asserting that disorder “alienated the minds of men everywhere ... from republican forms”; Jay to Washington, Jan. 7, 1787; to Adams, July 4, 1787, suggesting authority strong enough to ensure “national security and respectability”; and Report to Congress on a Joint Letter from Adams and Jefferson, May 29, 1786, regretting that problems of the United States were “common conversation in Europe.” Johnston, "), _c('em', [_vm._v("Jay Papers")]), _vm._v(", 394, 313-315, 319, 228, 248, 198.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench244"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench244"
    }
  }, [_vm._v("44")]), _vm._v(". Morris, "), _c('em', [_vm._v("Peacemakers")]), _vm._v(", passim.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench245"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench245"
    }
  }, [_vm._v("45")]), _vm._v(". Jay to Washington, Jan. 7, 1787, in Johnston, "), _c('em', [_vm._v("Jay Papers")]), _vm._v(", III, 226-227; Federalist No. 64 [63], in Cooke, "), _c('em', [_vm._v("Federalist")]), _vm._v(", 434; Jay speaking before Congress, in Wood, "), _c('em', [_vm._v("Creation")]), _vm._v(", 96.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench246"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench246"
    }
  }, [_vm._v("46")]), _vm._v(". Draft of John Jay’s Charge to the Grand Jury of the Circuit Court for the "), _c('a', {
    attrs: {
      "id": "page_63"
    }
  }), _vm._v("District of Virginia [before April 22, 1793], in Marcus, "), _c('em', [_vm._v("Documentary History")]), _vm._v(", II, 362 (much of which was muted in the final version delivered in Richmond, ibid., 380-391); Jay to James Duane, Sept. 16, 1795, in Johnston, "), _c('em', [_vm._v("Jay Papers")]), _vm._v(", IV, 193; Federalist No. 3, in Cooke, "), _c('em', [_vm._v("Federalist")]), _vm._v(", 14. For late-life musings about an immutable moral law “given by the Sovereign” and mutable “ordinances” that could not contradict God’s law, see Jay to John Murray, Jr., Apr. 15, 1818, in Johnston, "), _c('em', [_vm._v("Jay Papers")]), _vm._v(", IV, 403-419. This Calvinist framework comported well with his favored “individual-nation” analogy, which in turn was reinforced by readings in natural law and the law of nations. For the imagery couched in religious language, see Jay to Rev. Dr. Thatcher, May 26, 1796, ibid., Ill, 481, and IV, 215.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench247"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench247"
    }
  }, [_vm._v("47")]), _vm._v(". Jay to Jefferson, July 14, 1786, in Johnston, "), _c('em', [_vm._v("Jay Papers")]), _vm._v(", III, 207. On indebtedness, see Report to Congress on a Joint Letter from Adams and Jefferson, May 29, 1786, and Jay to Jefferson, Dec. 14, 1786, ibid., 198, 223. On Jay’s involvement in early agreements, see Jay to Floridablanca, June 22, 1780, and John Adams, Extract from a Journal, Nov. 3, 10, 1782, in Jared Sparks, ed., "), _c('em', [_vm._v("Diplomatic Correspondence of the American Revolution")]), _vm._v(" (12 vols., Boston 1830), VI, 465-466, 468-470, VII, 325.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench248"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench248"
    }
  }, [_vm._v("48")]), _vm._v(". Draft of John Jay’s Charge to the Grand Jury at. . . Virginia [before April 22, 1793], in Marcus, "), _c('em', [_vm._v("Documentary History")]), _vm._v(", II, 360; Letter to Congress incorporating a letter to the Count de Vergennes, Sept. 22, 1780, in Sparks, "), _c('em', [_vm._v("Diplomatic Correspondence")]), _vm._v(", VII, 384.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench249"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench249"
    }
  }, [_vm._v("49")]), _vm._v(". Jay to Governor Livingston, July 19, 1783, and Washington to Jay, Aug. 15, 1786, in Johnston, "), _c('em', [_vm._v("Jay Papers")]), _vm._v(", III, 55, 209; and Federalist No. 64 [63], in Cooke, "), _c('em', [_vm._v("Federalist")]), _vm._v(", 437. The Definitive Treaty of Peace is reprinted in Morris, "), _c('em', [_vm._v("Peacemakers")]), _vm._v(", 461-465. See also John Adams’s parallel sentiments, Extract from a Journal, Nov. 10, 1782, in Sparks, "), _c('em', [_vm._v("Diplomatic Correspondence")]), _vm._v(", VI, 473. On sequestration, see Goebel, "), _c('em', [_vm._v("History of the Supreme Court")]), _vm._v(", 722-759, or Morris, "), _c('em', [_vm._v("John Jay")]), _vm._v(", 73-102.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench250"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench250"
    }
  }, [_vm._v("50")]), _vm._v(". Jay to the Marquis de Lafayette, June 16, 1786, and to Lord Lansdowne, Apr. 20, 1786, but also see Jay to Lansdowne, Apr. 16, 1786, in Johnston, "), _c('em', [_vm._v("Jay Papers")]), _vm._v(", III, 192, 202, 190.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench251"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench251"
    }
  }, [_vm._v("51")]), _vm._v(". Jay to Adams, Feb. 21, 1787, ibid., Ill, 234-235, IV, 140; Charge to the Grand Jury of the Circuit Court for the District of New York, April 12, 1790, in Marcus, "), _c('em', [_vm._v("Documentary History")]), _vm._v(", II, 29; Jay to Edmund Randolph, Nov. 19, 1794, in Johnston, "), _c('em', [_vm._v("Jay Papers")]), _vm._v(", IV, 140. Active on revolutionary committees of safety, Jay did not sanction Loyalism, yet he was troubled by harsh treatment of men of merit. See Jay to Adams, Sept. 6, 1785, ibid., Ill, 166.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench252"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench252"
    }
  }, [_vm._v("52")]), _vm._v(". Jay’s papers do not confirm a direct Wilsonian influence, but the two served together in Congress and on the high court. Although Wilson’s assumptions were more “democratical” than Jay’s, structural similarities in the arguments of the two men are striking, as is a shared belief that the law of nations em-bodied "), _c('a', {
    attrs: {
      "id": "page_64"
    }
  }), _vm._v("divinity. See Arnaud Leavelle, “James Wilson and the Relation of the Scottish Metaphysics to American Political Thought,” "), _c('em', [_vm._v("Political Science Quarterly, 57")]), _vm._v(" (Sept. 1942), 394-410; Mary Delahanty, "), _c('em', [_vm._v("The Integrationist Philosophy of James Wilson")]), _vm._v(" (Millwood, N.Y. 1978); Charles Smith, "), _c('em', [_vm._v("James Wilson, Founding Father, 1742-1798")]), _vm._v(" (Chapel Hill 1956); Robert McCloskey, ed., "), _c('em', [_vm._v("The Works of James Wilson")]), _vm._v(" (2 vols., Cambridge, Mass. 1967).")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench253"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench253"
    }
  }, [_vm._v("53")]), _vm._v(". John Adams, Extract from a Journal, Nov. 3, 1782, in Sparks, "), _c('em', [_vm._v("Diplomatic Correspondence")]), _vm._v(", VI, 466.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench254"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench254"
    }
  }, [_vm._v("54")]), _vm._v(". Jay to Washington, Mar. 6, 1795, in Johnston, "), _c('em', [_vm._v("Jay Papers")]), _vm._v(", IV, 170, or Jay’s Letter to Congress, Nov. 6, 1780, in Sparks, "), _c('em', [_vm._v("Diplomatic Correspondence")]), _vm._v(", VII, 358. On revolutionary diplomatic theory, see Gregg Lint, “The American Revolution and the Law of Nations, 1776-1789,” "), _c('em', [_vm._v("Diplomatic History")]), _vm._v(", 1 (Winter 1977), 20-34, which identifies “enlightened” thought but not shrewdness, and J. H. Hutson, “Intellectual Foundations of Early American Diplomacy,” ibid., 1-19.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench255"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench255"
    }
  }, [_vm._v("55")]), _vm._v(". Jay to William Greene, Mar. 4, 1783, in Johnston, "), _c('em', [_vm._v("Jay Papers")]), _vm._v(", III, 33; Adams to Robert Livingston, Oct. 31, 1782, quoting Jay and agreeing with “sentiments and systems”; Sparks, "), _c('em', [_vm._v("Diplomatic Correspondence")]), _vm._v(", VI, 437, 473-474.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench256"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench256"
    }
  }, [_vm._v("56")]), _vm._v(". Letter to Congress, 1780, in Sparks, "), _c('em', [_vm._v("Diplomatic Correspondence")]), _vm._v(", VII, 247, 272-274. On unity against Britain, see Jay to Lafayette, July 15, 1785; on long-term economic prospects, see Jay to Jefferson, Apr. 24, 1788, and to Adams, Sept. 5, 1785; on China, see Jay to President of Congress, Jan. 20, 1786; in Johnston, "), _c('em', [_vm._v("Jay Papers")]), _vm._v(", III, 161, 165, 180, 326-327.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench257"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench257"
    }
  }, [_vm._v("57")]), _vm._v(". Jay to Benjamin Vaughan, Mar. 28, 1783, to Adams, Sept. 6, 1785, and to Jefferson, Jan. 9, 1786, Feb. 9, 1787, in Johnston, "), _c('em', [_vm._v("Jay Papers")]), _vm._v(", III, 34-35, 165, 178-179, 231-233; Letter to Congress, 1780, in Sparks, "), _c('em', [_vm._v("Diplomatic Correspondence")]), _vm._v(", VII, 275-276.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench258"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench258"
    }
  }, [_vm._v("58")]), _vm._v(". Useful studies of political economy include J. E. Crowley, "), _c('em', [_vm._v("This Sheba, Self")]), _vm._v(" (Baltimore 1974); Drew McCoy, "), _c('em', [_vm._v("The Elusive Republic")]), _vm._v(" (Chapel Hill 1980); Merrill Peterson, “Thomas Jefferson and Commercial Policy, 1783-1793,” "), _c('em', [_vm._v("William and Mary Quarterly")]), _vm._v(", 22 (Oct. 1965), 584-610; Joyce Appleby, “The Social Origins of American Revolutionary Ideology,” "), _c('em', [_vm._v("Journal of American History")]), _vm._v(", 64 (Mar. 1978), 935-958; John R. Nelson, Jr., “Alexander Hamilton and American Manufacturing: A Reexamination,” ibid., 65 (Mar. 1979), 971-995; Drew McCoy, “Republicanism and American Foreign Policy: James Madison and the Political Economy of Commercial Discrimination, 1789 to 1794,” "), _c('em', [_vm._v("William and Mary Quarterly")]), _vm._v(", 31 (1974), 633-646; Ralph Lerner, “Commerce and Character: The Anglo-American as a New-Model Man,” "), _c('em', [_vm._v("William and Mary Quarterly, 26")]), _vm._v(" (1979), 3-26; Joyce Appleby, "), _c('em', [_vm._v("Capitalism and a New Social Order: The Republican Vision of the 1790s")]), _vm._v(" (New York 1984); Cathy Matson and Peter Onuf, "), _c('em', [_vm._v("A Union of Interests: Political and Economic Thought in Revolutionary America")]), _vm._v(" (Lawrence, Kans. 1990); and, for intersections between commercial and international "), _c('a', {
    attrs: {
      "id": "page_65"
    }
  }), _vm._v("law, Peter Onuf and Nicholas Onuf, "), _c('em', [_vm._v("Federal Union, Modern World: The Law of Nations in an Age of Revolutions")]), _vm._v(" (Madison, Wis. 1993).")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench259"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench259"
    }
  }, [_vm._v("59")]), _vm._v(". Federalist No. 5, in Cooke, "), _c('em', [_vm._v("Federalist")]), _vm._v(", 26, and Letter to the President of Congress, May 26, 1780, in Sparks, "), _c('em', [_vm._v("Diplomatic Correspondence")]), _vm._v(", VII, 247.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench260"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench260"
    }
  }, [_vm._v("60")]), _vm._v(". Interestingly, Jay’s agrarianism seems to have lacked the moral preoccupations so much a part of republican agrarianism. He imagined wealth production, not seedbeds of republican virtue, although he would not have objected to the latter. See generally McCoy, "), _c('em', [_vm._v("Elusive Republic")]), _vm._v(", and (for a later period) John Ashworth, "), _c('em', [_vm._v("Agrarians and Aristocrats: Party Political Ideology in the United States, 1837-1846")]), _vm._v(" (London 1983). On this score, Jay was every inch the modernist.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench261"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench261"
    }
  }, [_vm._v("61")]), _vm._v(". Lansdowne to Jay, Sept 4,1785, and Jay to Lansdowne, Apr. 20, 1786, in Johnston, "), _c('em', [_vm._v("Jay Papers")]), _vm._v(", III, 189, 193. See also Jay to Jefferson, Apr. 24, 1788, ibid., 326-327.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench262"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench262"
    }
  }, [_vm._v("62")]), _vm._v(". Jay to Lansdowne, Apr. 20, 1786, to Jefferson, Apr. 24, 1788; to Lafayette, Apr. 26, 1788; and Address to the People of the State of New York, Spring 1788; ibid., 193-194, 314, 327-328. Additionally, see Federalist Nos. 3 and 4, in Cooke, "), _c('em', [_vm._v("Federalist")]), _vm._v(", passim.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench263"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench263"
    }
  }, [_vm._v("63")]), _vm._v(". Washington to Jay, Oct. 5, 1789, and Instructions to Envoy Extraordinary, May 6, 1794, in Johnston, "), _c('em', [_vm._v("Jay Papers")]), _vm._v(", III, 378-379, IV, 14.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench264"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench264"
    }
  }, [_vm._v("64")]), _vm._v(". Draft of John Jay’s Charge to the Grand Jury of the Circuit Court for the District of Virginia [before Apr. 22, 1793], in Marcus, "), _c('em', [_vm._v("Documentary History")]), _vm._v(", II, 359; Jay to Washington, Apr. 21, 1779, and Jay to John Vardill, May 23, 1774, in Morris, "), _c('em', [_vm._v("Unpublished Papers")]), _vm._v(", 587, 131. Before 1798, federal courts possessed original and exclusive jurisdiction in suits to which the United States was party, in admiralty, in suits touching consuls and ministers, and in litigation between states or a state and noncitizens. See Goebel, "), _c('em', [_vm._v("History of the Supreme Court")]), _vm._v(", 552-721.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench265"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench265"
    }
  }, [_vm._v("65")]), _vm._v(". Morris, "), _c('em', [_vm._v("John Jay")]), _vm._v(", 12. Jay’s support for this council has been viewed as evidence of his eagerness to garner implied powers of review, but an advisory role is conceptually distinct from the ability to negate congressional legislation after the fact.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench266"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench266"
    }
  }, [_vm._v("66")]), _vm._v(". George Washington to the Justices of the Supreme Court, Apr. 3, 1790, in Marcus, "), _c('em', [_vm._v("Documentary History")]), _vm._v(", II, 21.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench267"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench267"
    }
  }, [_vm._v("67")]), _vm._v(". Washington to Jay, June [?], 1789, Nov. 19, 1790; Jay to Washington, Nov. 13, 1790, to Alexander Hamilton, Nov. 28, 1790; and Hamilton to Jay Sept. 3, 1792, in Johnston, "), _c('em', [_vm._v("Jay Papers")]), _vm._v(", III, 369, 409, 405-408, 410, 446-447. See also Jay’s draft of Washington’s neutrality proclamation, ibid., 474-477.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench268"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench268"
    }
  }, [_vm._v("68")]), _vm._v(". John Jay’s Draft of the Charge to the Grand Jury of . . . Virginia [before Apr. 22, 1793], in Marcus, "), _c('em', [_vm._v("Documentary History")]), _vm._v(", II, 360.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench269"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench269"
    }
  }, [_vm._v("69")]), _vm._v(". Jay to George Read, Dec. 12, 1786, an unpublished letter quoted in Morris, "), _c('em', [_vm._v("John Jay, 26-27.")]), _c('a', {
    attrs: {
      "id": "page_66"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench270"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench270"
    }
  }, [_vm._v("70")]), _vm._v(". Judge-made criminal law exercised at the federal level held obvious appeal for Jay, whose vision of a stable polity depended upon swift punishment of wayward citizens, particularly when they threatened lawful government. In addition, Jay had tried crimes against government while serving on New York’s Committee of Safety (a job that he found distasteful), and held forth at length in grand jury charges after 1790 as to how and why the republic might enforce criminal sanctions. A recent study of Jay’s last reported case, "), _c('em', [_vm._v("U.S.")]), _vm._v(" v. "), _c('em', [_vm._v("Joseph Ravara")]), _vm._v(", confirms his interest in this murky jurisdiction; see John Gordon III, “"), _c('em', [_vm._v("United States")]), _vm._v(" v. "), _c('em', [_vm._v("Joseph Ravara:")]), _vm._v(" ‘Presumptuous Evidence’, ‘Too Many Lawyers’, and a Federal Common Law of Crime,” in Maeva Marcus, ed., "), _c('em', [_vm._v("Origins of the Federal Judiciary: Essays on the Judiciary Act of 1789")]), _vm._v(" (New York 1992), 106-172.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench271"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench271"
    }
  }, [_vm._v("71")]), _vm._v(". Ibid.; Jay to Washington, Jan. 7, 1787, in Johnston, "), _c('em', [_vm._v("Jay Papers")]), _vm._v(", III, 226. Early rulings included "), _c('em', [_vm._v("Oswald")]), _vm._v(" v. "), _c('em', [_vm._v("New York, 2")]), _vm._v(" Dallas 401, 415 (1792, 1793), or "), _c('em', [_vm._v("Van Staphorst")]), _vm._v(" v. "), _c('em', [_vm._v("Maryland, 2")]), _vm._v(" Dallas 401, 402 (1792, 1793). The Court’s docket is described in Goebel, "), _c('em', [_vm._v("History of the Supreme Court")]), _vm._v(", appendices, and (more usefully and painstakingly) in Marcus, "), _c('em', [_vm._v("Documentary History")]), _vm._v(", I, Part 1 (“Appointments and Proceedings”). On the importance of circuits as vehicles for instruction about the new federation, and also as a focus for judicial energies before 1795, see Ralph Lerner, “The Supreme Court as Republican Schoolmaster,” in Philip B. Kurland, ed., "), _c('em', [_vm._v("Supreme Court Review")]), _vm._v(" (Chicago 1967), 127-180.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench272"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench272"
    }
  }, [_vm._v("72")]), _vm._v(". "), _c('em', [_vm._v("Chisholm")]), _vm._v(" v. "), _c('em', [_vm._v("Georgia, 2")]), _vm._v(" Dallas 419 (1793). See also Doyle Mathis, "), _c('em', [_vm._v("“Chisholm")]), _vm._v(" v. "), _c('em', [_vm._v("Georgia:")]), _vm._v(" Background and Settlement,” "), _c('em', [_vm._v("Journal of American History")]), _vm._v(", 54 (June 1967), 19-29, correcting factual errors in earlier accounts. On the Judiciary Act and its contested sections, see essays and bibliography in Marcus, "), _c('em', [_vm._v("Origins of the Federal Judiciary")]), _vm._v(", and Wilfred Ritz, "), _c('em', [_vm._v("Rewriting the History of the Judiciary Act of 1789: Exposing Myths, Challenging Premises, and Using New Evidence")]), _vm._v(", ed. Wythe Holt and L. H. LaRue (Norman 1990).")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench273"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench273"
    }
  }, [_vm._v("73")]), _vm._v(". Jay to James Lowell, May 10, 1785; Draft of John Jay’s Charge to the Grand Jury of . . . Virginia [before Apr. 22, 1793], in Marcus, "), _c('em', [_vm._v("Documentary History")]), _vm._v(", II, 359-360. On Jay’s involvement with Oswald, Van Staphorst, and other creditors, see Harold Syrett, ed., "), _c('em', [_vm._v("Papers of Alexander Hamilton")]), _vm._v(" (26 vols., New York 1961-1979), VI, "), _c('em', [_vm._v("567-569;")]), _vm._v(" and John Adams’s description of meetings, Extract from a Journal, October 31 through November 15, 1782, in Sparks, "), _c('em', [_vm._v("Diplomatic Correspondence")]), _vm._v(", VII, 465-475.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench274"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench274"
    }
  }, [_vm._v("74")]), _vm._v(". "), _c('em', [_vm._v("Chisholm")]), _vm._v(" v. "), _c('em', [_vm._v("Georgia, 2")]), _vm._v(" Dallas 419, 422-423 (1793). At 424-425, Randolph argues that states exist only for “domestic purposes.” For the politics underlying James Iredell’s dissent, see Jeff Fordham, “Iredell’s Dissent in "), _c('em', [_vm._v("Chisholm")]), _vm._v(" v. "), _c('em', [_vm._v("Georgia:")]), _vm._v(" Its Political Significance,” "), _c('em', [_vm._v("North Carolina Historical Review")]), _vm._v(", 8 (Apr. 1931), 155-167.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench275"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench275"
    }
  }, [_vm._v("75")]), _vm._v(". "), _c('em', [_vm._v("Georgia")]), _vm._v(" v. "), _c('em', [_vm._v("Brailsford, 2")]), _vm._v(" Dallas 402, 415 (1792, 1793), and "), _c('em', [_vm._v("Chisholm")]), _vm._v(" v. "), _c('em', [_vm._v("Georgia, 2")]), _vm._v(" Dallas 419, 422-425, 473-474 (1793). The long-continued "), _c('em', [_vm._v("Brailsford")]), _vm._v(" case reappeared on the Supreme Court docket in 1798 to be dismissed in light of "), _c('a', {
    attrs: {
      "id": "page_67"
    }
  }), _vm._v("the Eleventh Amendment; see note 77. On "), _c('em', [_vm._v("Brailsford")]), _vm._v(" as a struggle mainly against judicial nationalism, see Haines, "), _c('em', [_vm._v("Role of the Supreme Court")]), _vm._v(", 93-104; and on Georgia’s several high court encounters, see Doyle Mathis, “Georgia before the Supreme Court,” "), _c('em', [_vm._v("American Journal of Legal History")]), _vm._v(", 12 (Apr. 1968), 112-121.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench276"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench276"
    }
  }, [_vm._v("76")]), _vm._v(". "), _c('em', [_vm._v("Chisholm")]), _vm._v(" v. "), _c('em', [_vm._v("Georgia, 2")]), _vm._v(" Dallas 409, 478-479 (1793).")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench277"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench277"
    }
  }, [_vm._v("77")]), _vm._v(". Marcus, "), _c('em', [_vm._v("Documentary History")]), _vm._v(", I, Part 1, 304-305.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench278"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench278"
    }
  }, [_vm._v("78")]), _vm._v(". Federalist No. 64 [63], in Cooke, "), _c('em', [_vm._v("Federalist")]), _vm._v(", 437, and Jay to Washington, Apr. 30, 1794, in Marcus, "), _c('em', [_vm._v("Documentary History")]), _vm._v(", I, Part 2, 747.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench279"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench279"
    }
  }, [_vm._v("79")]), _vm._v(". Jay to Adams, Jan. 2, 1801, in Johnston, "), _c('em', [_vm._v("Jay Papers")]), _vm._v(", IV, 285. Unlike Madison, Jay could not relinquish the ideal of organic homogeneity achieved through law, eschewing what Gordon Wood calls “mechanical devices and institutional contrivances” through which Federalists supposedly hoped to contain revolutionary “social forces,” without a clear object in mind beyond containment; Wood, "), _c('em', [_vm._v("Creation")]), _vm._v(", 428, 475-476. For Jay, law encompassed both substance and structure; the law of nations especially carried within it virtually flawless principles that, if heeded, eventually would make public morality actual and universal. Thus, while law served hegemonic purposes, Jay’s system also was organic and educative—and, in its way, progressive; he could not embrace the notion of machinery imposed for its own sake without abandoning the possibility of social redemption. This impasse may explain his existential despair after 1795.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench280"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench280"
    }
  }, [_vm._v("80")]), _vm._v(". Instructions as Envoy Extraordinary, May 6, 1794, and Jay to Lindley Murray, Aug. 22, 1794, in Johnston, "), _c('em', [_vm._v("Jay Papers")]), _vm._v(", IV, 14, 51. See also Jay to John Hartley, Jan. 8, 1795, and, on resignation and duty, Jay to Sarah Jay, Apr. 15, 1794, ibid., 3, 153. The notion that statesmen’s work might be limited to labor undertaken within particular institutions had not yet taken hold, even among proponents of departmentalized government; into the 1790s, Jefferson and others did the same thing, holding political and diplomatic posts at the same moment.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench281"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench281"
    }
  }, [_vm._v("81")]), _vm._v(". Jay to Washington, Aug. 5, 1794, to Rufus King, Nov. 19, 1794, to Edmund Randolph, Nov. 19, 1794, and to Washington, Mar. 6, 1795, ibid., IV, 45, 136, 140, 170-171. On treaty negotiations, see Combs, "), _c('em', [_vm._v("Jay Treaty")]), _vm._v(", esp. his discussion of the mixed commission, 151-155.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench282"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench282"
    }
  }, [_vm._v("82")]), _vm._v(". Charge to the Grand Jury of the Circuit Court for the District of Virginia [Richmond], May 22, 1793, in Marcus, "), _c('em', [_vm._v("Documentary History")]), _vm._v(", II, 390-391.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench283"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench283"
    }
  }, [_vm._v("83")]), _vm._v(". Fischer, "), _c('em', [_vm._v("Revolution in American Conservatism")]), _vm._v(", 10.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench284"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench284"
    }
  }, [_vm._v("84")]), _vm._v(". Ralph Lerner, “Commerce and Character: The Anglo-American as a New-Model Man,” "), _c('em', [_vm._v("William and Mary Quarterly, 26")]), _vm._v(" (1979), 3-26.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench285"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench285"
    }
  }, [_vm._v("85")]), _vm._v(". Jay to George Read, 1786, quoted in Morris, "), _c('em', [_vm._v("John Jay, 21.")]), _vm._v(" On republicanism and Federalist objects in 1787, see early discussions (and, in some cases, texts epitomizing the so-called “republican synthesis”) such as Wood, "), _c('em', [_vm._v("Creation;")]), _vm._v(" Bernard Bailyn, "), _c('em', [_vm._v("Ideological Origins of the American Revolution")]), _vm._v(" (Cambridge, "), _c('a', {
    attrs: {
      "id": "page_68"
    }
  }), _vm._v("Mass. 1967); the long introduction in Jack Greene, ed., "), _c('em', [_vm._v("Reinterpretation of the American Revolution")]), _vm._v(" (New York 1968); two classic articles by Robert Shalhope, “Toward a Republican Synthesis: The Emergence of an Understanding of Republicanism in American Historiography,” "), _c('em', [_vm._v("William and Mary Quarterly")]), _vm._v(" ‘, 29 (Jan. 1972), 49-80, and “Republicanism and Early American Historiography,” ibid., 39 (Apr. 1982), 334-356; John Murrin, “The Great Inversion, or Court versus Country . . . ,” in J. G. A. Pocock, ed., "), _c('em', [_vm._v("Three British Revolutions: 1641, 1688, 1776")]), _vm._v(" (Princeton 1988); and a special issue of the "), _c('em', [_vm._v("American Quarterly")]), _vm._v(" (Fall 1985), ed. Joyce Appleby. For recent attempts to marry republican and liberal discourses, to declare them irreconcilably divorced, or to pronounce republicanism an outmoded idea, see Milton Klein et al., eds., "), _c('em', [_vm._v("The Republican Synthesis Revisited: Essays in Honor of George Athan Billias")]), _vm._v(" (Worcester, Mass. 1992); Isaac Kramnick, "), _c('em', [_vm._v("Republicanism and Bourgeois Radicalism: Political Ideology in Late Eighteenth-Century England and America")]), _vm._v(" (Ithaca 1990), esp. ch. 9; Joyce Appleby, "), _c('em', [_vm._v("Liberalism and Republicanism in the Historical Imagination")]), _vm._v(" (Cambridge, Mass. 1992); Scott Douglas Gerber, "), _c('em', [_vm._v("To Secure These Rights: The Declaration of Independence and Constitutional Interpretation")]), _vm._v(" (New York 1995), Part I; and (for allegations of bankruptcy) Daniel Rodgers, “Republicanism: The Career of a Concept,” "), _c('em', [_vm._v("Journal of American History’")]), _vm._v(", 79 (1992), 11-38. These works also contain extensive bibliographic information.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench286"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench286"
    }
  }, [_vm._v("86")]), _vm._v(". Draft of John Jay’s Charge to the Grand Jury at. . . Virginia [before Apr. 22 1793], in Marcus, "), _c('em', [_vm._v("Documentary History")]), _vm._v(", II, 361-362. Cf. Stephen Presser, “A Tale of Two Judges,” "), _c('em', [_vm._v("Northwestern University Law Review")]), _vm._v(", 73 (Mar.-Apr. 1978), 48-52.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench287"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench287"
    }
  }, [_vm._v("87")]), _vm._v(". Federalist No. 2, in Cooke, "), _c('em', [_vm._v("Federalist")]), _vm._v(", 8.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench288"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench288"
    }
  }, [_vm._v("88")]), _vm._v(". John Jay’s Charge to the Grand Jury of the Circuit Court for the District of New York, Apr. 12, 1790, in Marcus, "), _c('em', [_vm._v("Documentary History")]), _vm._v(", II, 30. Jay delivered essentially the same charge on circuit in Massachusetts, Connecticut, and other eastern states.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench289"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench289"
    }
  }, [_vm._v("89")]), _vm._v(". Letter to Congress, Sept. 22, 1780, in Sparks, "), _c('em', [_vm._v("Diplomatic Correspondence")]), _vm._v(", 384.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench290"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench290"
    }
  }, [_vm._v("90")]), _vm._v(". For a brief account of the episode, see Morris, "), _c('em', [_vm._v("John Jay")]), _vm._v(", 100-101.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench291"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench291"
    }
  }, [_vm._v("91")]), _vm._v(". John Noonan, Jr., "), _c('em', [_vm._v("Persons and Masks of the Law")]), _vm._v(" (New York 1976), 163. On Whiggish representation in legal-historical studies, see Robert Gordon, “Recent Trends in Legal Historiography,” "), _c('em', [_vm._v("Law Library Journal")]), _vm._v(", 69 (Nov. 1976), 462-468, esp. 465; “Introduction,” "), _c('em', [_vm._v("Law and Society Review")]), _vm._v(", 10 (Fall 1975), "), _c('em', [_vm._v("9-55;")]), _vm._v(" and “Historicism in Legal Scholarship,” "), _c('em', [_vm._v("Yale Law Journal")]), _vm._v(", 90 (Apr. 1981), 1017-1059. See also Harry Scheiber’s odd suggestion that constitutional history, unlike its private law counterpart, has been more or less impervious to criticism; “American Constitutional History and the New Legal History: Complementary Themes in Two Modes,” "), _c('em', [_vm._v("Journal of American History")]), _vm._v(", 68 (Sept. 1981), 337-350. For additional essays, see Kermit Hall, ed., "), _c('em', [_vm._v("United States Constitutional and")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_69"
    }
  }), _c('em', [_vm._v("Legal History")]), _vm._v(", Vol. I, "), _c('em', [_vm._v("Main Themes in U.S. Constitutional and Legal History")]), _vm._v(" (New York 1987).")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench292"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench292"
    }
  }, [_vm._v("92")]), _vm._v(". Morris, "), _c('em', [_vm._v("John Jay")]), _vm._v(", 86. The Court’s cumulative experience on circuit with the review question can be tracked fairly easily in Marcus, "), _c('em', [_vm._v("Documentary History")]), _vm._v(", II, “The Justices on Circuit.” On this question and others, the "), _c('em', [_vm._v("Documentary History")]), _vm._v(" is indispensable.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench293"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench293"
    }
  }, [_vm._v("93")]), _vm._v(". John Jay’s Charge to the Grand Jury of the Circuit Court for the District of New York, Apr. 12, 1790, in Marcus, "), _c('em', [_vm._v("Documentary History")]), _vm._v(", II, 27; and Alexander Hamilton, Federalist No. 78, in Cooke, "), _c('em', [_vm._v("Federalist")]), _vm._v(", 523. On procedural innovation, see Goebel’s decidedly unappreciative "), _c('em', [_vm._v("History of the Supreme Court")]), _vm._v(", passim.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench294"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench294"
    }
  }, [_vm._v("94")]), _vm._v(". White, "), _c('em', [_vm._v("American Judicial Tradition")]), _vm._v(", 2-3.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "id": "ench295"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/#iench295"
    }
  }, [_vm._v("95")]), _vm._v(". Morris, "), _c('em', [_vm._v("John Jay")]), _vm._v(", 102.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22ac7106","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter2.vue
// module id = 81
// module chunks = 0